import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import {
  getExhibitorEntryPassDetails_action,
  submitExhibitorEntryPass_action, updateExhibitorEntryPass_action,
  getAccountEntryPassDetail_action, deleteEntryPass_action, deleteEntryPassDriverDoc_action
} from "../../../actions/exhibitor_module_actions/exhibitorEntryPass_action/exhibitorEntryPass_action";
import { fill_action } from "../../../actions/fillCombo_action";
import { getVendorBasicDetail_action } from "../../../actions/vendor_module_action/vendor_order_action";
import { connect } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Resizer from "react-image-file-resizer";
import {
  contractorListActionId,
  toastError,
  toastSuccess,
  fetchAuthReport,
  exhibitorBadgeDaysActionId,
  downloadReport, vehicleTypeActionId,
  link_BASE_URL,
} from "../../../utils/constants";
import $ from "jquery";
import moment from "moment";
import AdminHeader from "../../../common_components/admin_module_header";
import DatePicker from "react-datepicker";
import Modal from "react-modal";
import { emailValidator, mobileNoValidator } from "../../../utils/Validator";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import {
  getAccountEntryPassList_action,
  getEntryPassPdf_action,
} from "../../../actions/admin_module_action/account_entry_pass_action/account_entry_pass_action";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import ConfirmationModal from "../../../common_components/confirmationa_modal";

class ExhibitorEntryPass extends Component {
  // Initialize Constructor
  constructor(props) {
    super(props);
    //States
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      categoryType:
        sessionStorage.getItem("RoleIDSS") == 1
          ? "Exhibitor"
          : sessionStorage.getItem("RoleIDSS") == 7
            ? "contractor"
            : "contractor",
      itemToCarryList: [
        { Name: "", Quantity: "", Nameerr: false, Quantityerr: false },
      ],
      contractorList: [],
      delID: '',
      isDelOpen: false,
      ContractorId: null,
      exhibitorDetailsData: {},
      personName: "",
      personNameErr: "",
      companyName: "",
      companyNameErr: "",
      email: "",
      emailErr: "",
      contactNo: "",
      contactNoErr: "",
      EntryDate: '',
      categoryList: [],
      isOpen: false,
      EntryDateErr: "",
      QrCodeImg: "",
      RoleId: sessionStorage.getItem("RoleIDSS"),
      exhUUID: "",
      contractorUUID: "",
      isCopyModal: false,
      isCopied: false,
      copiedIndex: "",
      isDirectContractor: false,

      isView: false,
      ExhID: "",
      entryPassId: "",
      stEntry: "",
      vendorBasicData: null,
      isVendor: sessionStorage.getItem("RoleIDSS") == 7 ? 1 : 0,

      mailDataPersonName: "",
      mailDatacompanyName: "",
      mailDatacontactNo: "",
      mailDataemail: "",

      editOpen: false,
      editIndex: null,
      editEntryHdrId: '',
      editEntryHdrNo: '',
      editListItemsTocarry: [],
      editListOfVehicles: [],
      deletePop: false,
      showVideoModal: false,
      setupDate: '',
      dismantleDate: '',
      showEntryPass: false,
      noOfVehicles: '',
      noOfVehiclesErr: '',
      editNoOfVehicles: '',
      listOfVehicles: [],
      vehicleTypeList: [],
      editNoOfVehiclesErr: '',
      tempListOfVehicles: [],
      tempMainListOfVehicles: [],
      mainListOfVehicles: [],
    };

    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.onPassDownload = this.onPassDownload.bind(this);
    this.deleteEntryPass = this.deleteEntryPass.bind(this);
    this.onPassPrint = this.onPassPrint.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
    this.onChangeEditNoOFVehicles = this.onChangeEditNoOFVehicles.bind(this)
    this.renderNewImage = this.renderNewImage.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.setState({ editIndex: popArg[0], editListItemsTocarry: popArg[1], editEntryHdrId: popArg[2], editEntryHdrNo: popArg[3], editListOfVehicles: popArg[4], editNoOfVehicles: popArg[5] }, () => this.updateExhibitorEntryPass(popArg[6]))
      }
      if (confirmationObj.action == 1) {
        this.onPassDownload(popArg[0])
      }
      if (confirmationObj.action == 2) {
        this.onPassPrint(popArg[0])
      }
      if (confirmationObj.action == 3) {
        this.updateExhibitorEntryPass(popArg[0])
      }
      if (confirmationObj.action == 4) {
        this.updateExhibitorEntryPass(popArg[0])
      }
      if (confirmationObj.action == 5) {
        this.submitExhibitorEntryPass(popArg[0])
      }
      if (confirmationObj.action == 6) {
        this.submitExhibitorEntryPass(popArg[0])
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    const { contractorList, RoleId } = this.state;
    console.log(sessionStorage.getItem("RoleIDSS"));

    // Call vendor details if vendor login
    if (RoleId == 7) {
      this.getVendorBasicDetails();
    }

    var fullUrl = window.location.href;
    fullUrl = fullUrl.split("/");
    if (fullUrl.length == 8) {
      this.setState({ isDirectContractor: true });

      sessionStorage.setItem("sessionExhibitionID", fullUrl[6]);
      this.getFillList(vehicleTypeActionId, "", "", "", "", "")
      this.getExhibitorEntryPassDetails(fullUrl[7], fullUrl[6]).then(() => {
        this.getFillList(contractorListActionId, "", "", "", "", "").then(
          (arr) => {
            arr.length > 0 &&
              arr.forEach((item) => {
                console.log(item.UUID, fullUrl[5]);
                if (item.UUID == fullUrl[5]) {
                  this.setState({ ContractorId: item.ContractorID }, () => {
                    this.getExhibitorEntryPassDetails(
                      fullUrl[7],
                      fullUrl[6]
                    ).then(() => { });
                  });
                }
              });
          }
        );
      });
    } else {
      if (this.props.location.state) {
        if (
          this.props.location.state.isExhibitor != null &&
          this.props.location.state.isExhibitor != undefined
        ) {
          this.setState({
            categoryType: this.props.location.state.isExhibitor
              ? "Exhibitor"
              : "contractor",
          });
          this.setState({ isView: this.props.location.state.is_view });
          this.setState({ entryPassId: this.props.location.state.entryId });
          this.setState({ ContractorId: this.props.location.state.vendorID });
          this.setState({ ExhID: this.props.location.state.regId });
          this.setState({ isVendor: this.props.location.state.isVendor || 0 });
          console.log(
            this.props.location.state.isVendor,
            "this.props.location.state.isVendor"
          );
          console.log(
            this.props.location.state.regId,
            "this.props.location.state.vendorID",
            this.props.location.state.vendorID
          );
          if (this.props.location.state.vendorID == null) {
            this.setState({ stEntry: "Exhibitor" });
          } else {
            this.setState({ stEntry: "Contractor" });
          }
          // if (this.props.location.state.isExhibitor) {
          //     this.setState({ ExhID: this.props.location.state.regId, ContractorId: '' })
          // } else {
          //     this.setState({ ContractorId: this.props.location.state.regId, ExhID: '' })
          // }
          if (this.props.location.state.otherInfo != null) {
            this.setState({
              mailDatacompanyName:
                this.props.location.state.otherInfo.companyName,
              mailDataPersonName:
                this.props.location.state.otherInfo.personName,
              mailDatacontactNo: this.props.location.state.otherInfo.contactNo,
              mailDataemail: this.props.location.state.otherInfo.email,
            });
          }
        }
      }
      this.getFillList(contractorListActionId, "", "", "", "", this.props.location.state != null ? this.props.location.state.regId != '' && this.props.location.state.regId != null ? this.props.location.state.regId : '' : '');
      this.getFillList(vehicleTypeActionId, "", "", "", "", this.props.location.state != null ? this.props.location.state.regId != '' && this.props.location.state.regId != null ? this.props.location.state.regId : '' : '');
      setTimeout(() => {
        this.getExhibitorEntryPassDetails();
      }, 200);
    }
    this.loadscript();
  }

  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID
  ) {
    return new Promise((resolve, reject) => {
      const { } = this.state;
      this.setState({ isLoading: true });
      this.props
        .fill_action(
          actionID,
          exhibitionID,
          moduleID,
          keyValue,
          value,
          exhRegistrationID
        )
        .then((data) => {
          if (data.error != 1) {
            // Instrument Type list
            if (actionID === contractorListActionId) {
              const array = [];
              data.data.map((item, i) => {
                array.push(item);
              });
              // array.push({ ContractorID: 0, CompanyName: "Other" });
              this.setState(
                {
                  contractorList: array,
                  //  isLoading: false,
                },
                () => {
                  resolve(array);
                }
              );
            }
            if (actionID === vehicleTypeActionId) {
              const array = [];
              data.data.map((item, i) => {
                array.push(item);
              });
              // array.push({ ContractorID: 0, CompanyName: "Other" });
              this.setState(
                {
                  vehicleTypeList: array,
                  //  isLoading: false,
                },
                () => {
                  resolve(array);
                }
              );
            }
          } else {

            this.setState({ isLoading: false });
            toastError(data.msg);
            reject(data.msg);
          }
        })
        .catch((e) => {
          this.setState({ isLoading: false });
          console.log(e);
          reject(e);
        });
    });
  }

  inputValidate() {
    const {
      personName,
      companyName,
      contactNo,
      email,
      EntryDate,
      categoryType,
      ContractorId,
    } = this.state;

    if (EntryDate == "" || EntryDate == null) {
      this.setState({ EntryDateErr: "Please select Entry Date" });
    }
    if (categoryType == "contractor" && ContractorId == 0) {
      if (personName == "" || personName == null) {
        this.setState({ personNameErr: "Please Enter Person Name" });
      }
      if (companyName == "" || companyName == null) {
        this.setState({ companyNameErr: "Please Enter Company Name" });
      }
      if (contactNo == "" || contactNo == null) {
        this.setState({ contactNoErr: "Please Enter Contact No." });
      }
      if (contactNo != "") {
        var contactNoError = mobileNoValidator(contactNo);
        if (contactNoError != "") {
          this.setState({ contactNoErr: contactNoError });
        }
      }
      if (email == "" || email == null) {
        this.setState({ emailErr: "Please enter Email" });
      }
      if (email != "") {
        var emailError = emailValidator(email);
        if (emailError != "") {
          this.setState({ emailErr: emailError });
        }
      }
    }
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  handleOpenForm(ID, deadline, StatusID, name, ServiceID) {
    this.props.navigate("/manualFormsVendorList", {
      state: {
        Deadline: deadline,
        StatusID,
        ManualFormsID: ID,
        ManualFormsName: name,
        ServiceID: ServiceID,
      },
    });
  }

  deleteEntryPass() {
    const { ContractorId, isView, entryPassId, editEntryHdrId } = this.state;
    // return new Promise((resolve, reject) => {
    this.setState({ isLoading: true });
    console.log("ContractorId--------->", ContractorId);
    // if (isView) {
    this.props
      .deleteEntryPass_action(editEntryHdrId)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: true });
          // if (mode == 4) {
          // toastSuccess("Exit pass saved as draft successfully!");
          // } else {
          toastSuccess("Entry pass deleted successfully!");
          // }
          this.getExhibitorEntryPassDetails()
          this.setState({
            // companyName: '',
            // personName: '',
            // contactNo: '',
            // email: '',
            // categoryType:
            //   sessionStorage.getItem("RoleIDSS") == 1
            //     ? "Exhibitor"
            //     : sessionStorage.getItem("RoleIDSS") == 7
            //       ? "contractor"
            //       : "contractor",
            editListItemsTocarry: [], editIndex: null, editOpen: false, editEntryHdrId: '', deletePop: false, editListOfVehicles: []
          })
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
          // reject(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
        // reject(err);
      });
    // }
    // })
  }

  deleteEntryPassDoc() {
    const { ContractorId, isView, categoryList, mainListOfVehicles, entryPassId, delID, editEntryHdrId, listOfVehicles, editListOfVehicles } = this.state;
    // const { isSSIandTMMAITAMMMA, delChapterID, exhibitDetailsList, } = this.state
    // e != undefined && e.preventDefault()
    // const { isDel2Open, logoImg, exhRegistrationID, isDel1Open, exhibitionID, SSIDocumentPath, isSSifile, isSSIdeleted, TMMAITAMMAfile, isTMMAITAMMAdeleted } = this.state
    this.setState({ isLoading: true })
    this.props.deleteEntryPassDriverDoc_action(delID, null)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(" Document Deleted SuccessFully")
          var ExhEntryPassHdrIDtemp = ''
          editListOfVehicles.map(item => {
            if (item.EntryVehicleDtlID == delID) {
              item.driverDocFile = ''
              item.driverDocName = ''
              item.driverDocPath = ''
              item.driverDocType = ''
              item.DriverDocument = ''
              item.driverDocdeleted = true
              ExhEntryPassHdrIDtemp = item.ExhEntryPassHdrID[0]
            }
          })
          mainListOfVehicles.map(item => {
            if (item.EntryVehicleDtlID == delID) {
              item.driverDocFile = ''
              item.driverDocName = ''
              item.driverDocPath = ''
              item.driverDocType = ''
              item.DriverDocument = ''
              item.driverDocdeleted = true
              ExhEntryPassHdrIDtemp = item.ExhEntryPassHdrID[0]
            }
          })

          categoryList.map(item => {
            if (item.ExhEntryPassHdrID == ExhEntryPassHdrIDtemp) {
              item.vehicleList.length > 0 && item.vehicleList.map(item2 => {
                if (item2.EntryVehicleDtlID == delID) {
                  item2.driverDocFile = ''
                  item2.driverDocName = ''
                  item2.driverDocPath = ''
                  item2.driverDocType = ''
                  item2.DriverDocument = ''
                  item2.driverDocdeleted = true
                }

              })
            }
          })
          this.getExhibitorEntryPassDetails()
          this.setState({ isLoading: false, isDelOpen: false, editListOfVehicles: editListOfVehicles, categoryList: categoryList })
        } else {
          toastError(data.msg)
          this.setState({ isLoading: false })
        }
      }).catch((error) => {
        console.log(error)
      })
  }

  getExhibitorEntryPassDetails(UUID, exhibitionID) {
    const { ContractorId, isView, entryPassId } = this.state;
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true });
      if (isView) {
        this.props
          .getAccountEntryPassDetail_action(entryPassId)
          .then((data) => {
            if (data.error != 1) {
              if (data.data.length > 0) {
                data.data[4].length > 0 && data.data[4].map(item => {
                  var filePath = item.DriverDocument
                  var docarray = item.DriverDocument != null && item.DriverDocument != "" && filePath.split("/")
                  var FileName = docarray[docarray.length - 1]
                  item.driverDocName = FileName
                  item.driverDocPath = filePath
                  item.driverDocdeleted = false
                })
                const array = [];
                data.data[1].forEach((item) => {
                  item.itemToCarryList = data.data[2].filter(
                    (obj) => obj.ExhEntryPassHdrID === item.ExhEntryPassHdrID
                  );
                  item.vehicleList = data.data[4].filter(
                    (obj) => obj.ExhEntryPassHdrID === item.ExhEntryPassHdrID
                  );
                  array.push(item);
                });
                console.log('array', array)

                if (data.data[1].length > 0) {
                  this.setState({
                    personName: data.data[1][0].PersonName,
                    companyName: data.data[1][0].CompanyName,
                    contactNo: data.data[1][0].MobileNo,
                    email: data.data[1][0].EmailID,
                  });
                }
                this.setState({
                  isLoading: false,
                  exhibitorDetailsData: data.data[0][0],
                  categoryList: array,
                  itemToCarryList: [
                    {
                      Name: "",
                      Quantity: "",
                      Nameerr: false,
                      Quantityerr: false,
                    },
                  ],
                  exhUUID: data.data[0][0]?.UUID || "",
                });
                console.log('ccvvcc')
                // console.log(data.data[3][0].SetupStartDate, '////', new Date(), moment(data.data[3][0].SetupStartDate).format('YYYY-MM-DD'))
                if (data.data[3].length > 0) {
                  this.setState({
                    setupDate: moment(data.data[3][0].SetupStartDate).format('YYYY-MM-DD'),
                    dismantleDate: moment(data.data[3][0].DismantleEndDate).format('YYYY-MM-DD'),
                    EntryDate: moment(data.data[3][0].SetupStartDate).format('YYYY-MM-DD')
                  });
                }
              }
              this.setState({ isLoading: false });
              resolve(true);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
              reject(data.msg);
            }
          })
          .catch((err) => {
            this.setState({ isLoading: false });
            console.log(err);
            reject(err);
          });
      } else {
        console.log(UUID);
        this.props
          .getExhibitorEntryPassDetails_action(
            ContractorId,
            UUID != null && UUID != "" && UUID != undefined ? UUID : null,
            exhibitionID != null &&
              exhibitionID != "" &&
              exhibitionID != undefined
              ? exhibitionID
              : null
          )
          .then((data) => {
            if (data.error != 1) {
              if (data.data.length > 0) {
                data.data[4].length > 0 && data.data[4].map(item => {
                  var filePath = item.DriverDocument
                  var docarray = item.DriverDocument != null && item.DriverDocument != "" && filePath.split("/")
                  var FileName = docarray[docarray.length - 1]
                  item.driverDocName = FileName
                  item.driverDocPath = filePath
                  item.driverDocdeleted = false
                })
                const array = [];
                data.data[1].forEach((item) => {
                  item.itemToCarryList = data.data[2].filter(
                    (obj) => obj.ExhEntryPassHdrID === item.ExhEntryPassHdrID
                  );
                  item.vehicleList = data.data[4].filter(
                    (obj) => obj.ExhEntryPassHdrID[0] === item.ExhEntryPassHdrID
                  );
                  array.push(item);
                });
                console.log('array', array)
                // Don't overwrite exhibitorDetailsData for vendor (RoleId == 7)
                const updateData =
                  sessionStorage.getItem("RoleIDSS") == 7
                    ? {
                      isLoading: false,
                      categoryList: array,
                      itemToCarryList: [
                        {
                          Name: "",
                          Quantity: "",
                          Nameerr: false,
                          Quantityerr: false,
                        },
                      ],
                      exhUUID: data.data[0][0]?.UUID || "",
                    }
                    : {
                      isLoading: false,
                      exhibitorDetailsData: data.data[0][0],
                      categoryList: array,
                      itemToCarryList: [
                        {
                          Name: "",
                          Quantity: "",
                          Nameerr: false,
                          Quantityerr: false,
                        },
                      ],
                      exhUUID: data.data[0][0]?.UUID || "",
                    };
                this.setState(updateData);
                if (data.data[0][0]?.ExhRegistrationID) {
                  sessionStorage.setItem(
                    "ExhRegistrationIDSS",
                    data.data[0][0].ExhRegistrationID
                  );
                }

                this.setState({
                  showEntryPass: sessionStorage.getItem("RoleIDSS") == 1 ? !data.data[0][0]?.IsFullSpacePaid : false,
                });

                console.log(data.data[3][0].SetupStartDate, '//', new Date())
                if (data.data[3].length > 0) {
                  this.setState({
                    setupDate: data.data[3][0].SetupStartDate,
                    dismantleDate: data.data[3][0].DismantleEndDate,
                    EntryDate: data.data[3][0].SetupStartDate
                  });
                }
                resolve(true);
              }
              this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
              reject(data.msg);
            }
          })
          .catch((err) => {
            this.setState({ isLoading: false });
            console.log(err);
            reject(err);
          });
      }
    });
  }

  handleClearErr() {
    this.setState({
      companyNameErr: "",
      personNameErr: "",
      contactNoErr: "",
      emailErr: "",
      companyName: "",
      personName: "",
      contactNo: "",
      email: "",
    });
  }

  updateExhibitorEntryPass(mode) {
    const {
      EntryDate,
      ContractorId,
      isView,
      contractorList,
      ExhID,
      categoryType,
      companyName,
      personName,
      email,
      contactNo,
      itemToCarryList,
      emailErr,
      contactNoErr,
      RoleId,
      exhibitorDetailsData, editExitHdrId, editListOfVehicles, editNoOfVehicles,
      vendorBasicData, editEntryHdrId, editListItemsTocarry, editEntryHdrNo,
    } = this.state;
    editListItemsTocarry.forEach((item) => {
      item.ItemName.trim()
      if (item.ItemName.trim() == "") {
        item.Nameerr = true;
      }
    });
    console.log(
      editListItemsTocarry
    );
    editListItemsTocarry.forEach((item) => {
      item.ItemName.trim()
      if (item.Quantity == '' || item.Quantity == null) {
        item.Quantityerr = true;
      }
    });
    this.setState({ editListItemsTocarry: editListItemsTocarry });
    const condition = editListItemsTocarry.some((item) => item.ItemName?.trim() == "");
    if (condition) {
      return toastError("Please fill all item names");
    }
    const condition2 = editListItemsTocarry.some(
      (item) => item.Quantity == '' || item.Quantity == null
    );
    if (condition2) {
      return toastError("Please fill quantity of all items");
    }
    var isDuplicate = false;
    for (var i = 0; i < editListItemsTocarry.length; i++) {
      for (var j = 0; j < editListItemsTocarry.length; j++) {
        // console.log(
        //   editListItemsTocarry[i].ItemName == editListItemsTocarry[j].Name,
        //   editListItemsTocarry[i].Name,
        //   editListItemsTocarry[j].Name
        // );
        if (i != j) {
          if (editListItemsTocarry[i].ItemName == editListItemsTocarry[j].ItemName) {
            isDuplicate = true;
            break;
          }
        }
      }
    }
    editListOfVehicles.length > 0 && editListOfVehicles.map((item => {
      item.type = item.VehicleTypeID
      item.driverName = item.DriverName
      item.driverNo = item.DriverMobNo
      item.VehicleNo = item.VehicleNo
      item.driverDocType = item.driverDocType ?? ''
      item.driverDocFile = item.driverDocFile ?? ''
    }))
    if (editNoOfVehicles == '' || editNoOfVehicles == null || editNoOfVehicles < 1) {
      this.setState({
        editNoOfVehiclesErr: 'Please enter atleast 1 vehicle'
      })
      return toastError("Please enter atleast 1 vehicle");
    }
    console.log(editNoOfVehicles)
    if (editNoOfVehicles != '' && editNoOfVehicles != null) {
      const condition3 = editListOfVehicles.some((item) => item.driverName?.trim() == "");
      if (condition3) {
        return toastError("Please fill all driver names");
      }
      const condition4 = editListOfVehicles.some((item) => item.type == '' || item.type == null);
      if (condition4) {
        return toastError("Please select all vehicle types");
      }
      const condition7 = editListOfVehicles.some((item) => item.VehicleNo == '' || item.VehicleNo == null);
      if (condition7) {
        return toastError("Please fill all Vehicle No");
      }
      const condition5 = editListOfVehicles.some((item) => item.driverNo == '' || item.driverNo == null);
      if (condition5) {
        return toastError("Please fill all driver mobile No");
      }
      const condition6 = editListOfVehicles.some((item) => (item.driverDocPath == '' || item.driverDocPath == null) && (item.driverDocType == '' || item.driverDocType == null));
      if (condition6) {
        return toastError("Please enter all driver documents");
      }
    }
    console.log(editListOfVehicles);
    if (isDuplicate) {
      toastError("Duplicate items names is not allowed");
      return;
    }
    this.setState({ isLoading: true });
    this.props
      .updateExhibitorEntryPass_action(editEntryHdrId, editEntryHdrNo,
        editListItemsTocarry, ContractorId,
        isView ? ExhID : "",
        {
          person: exhibitorDetailsData?.["Contact Person"]
            ? exhibitorDetailsData?.["Contact Person"]
            : exhibitorDetailsData?.["Person Name"],
          PrimaryEmail: exhibitorDetailsData?.["PrimaryEmail"]
            ? exhibitorDetailsData?.["PrimaryEmail"]
            : exhibitorDetailsData?.["Email ID"],
          ExhibitionName: sessionStorage.getItem("ExhibitionName"),
        },
        mode, editNoOfVehicles, editListOfVehicles
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.data.length > 0) {
            if (mode == 2) {
              toastSuccess("Entry pass submitted successfully!");
            } else {
              toastSuccess("Entry pass saved as draft successfully!");
            }
            this.getExhibitorEntryPassDetails();
            setTimeout(() => {
              this.setState({
                // companyName: '',
                // personName: '',
                // contactNo: '',
                // email: '',
                // categoryType:
                //   sessionStorage.getItem("RoleIDSS") == 1
                //     ? "Exhibitor"
                //     : sessionStorage.getItem("RoleIDSS") == 7
                //       ? "contractor"
                //       : "contractor",
                editListItemsTocarry: [], editIndex: null, editOpen: false, editListOfVehicles: [], editNoOfVehicles: '', tempMainListOfVehicles: []
              })
            }, 500);
            this.setState({ isLoading: false });
          }
          setTimeout(() => {
            if (isView) {
              this.props.navigate("/accountEntryPassList");
            }
          }, 1000);
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
  }
  submitExhibitorEntryPass(mode) {
    const {
      EntryDate, editOpen,
      ContractorId,
      isView,
      contractorList,
      ExhID,
      categoryType,
      companyName, noOfVehicles,
      personName,
      email,
      contactNo,
      itemToCarryList,
      emailErr,
      contactNoErr,
      RoleId,
      exhibitorDetailsData, listOfVehicles,
      vendorBasicData,
    } = this.state;
    // this.inputValidate();
    if (editOpen) {
      toastError("Please cancel the edit entry pass before submitting new")
      return
    }
    var startErr = false
    if (EntryDate == "" || EntryDate == null) {
      startErr = true
      this.setState({ EntryDateErr: "Please select Entry Date" });
    }
    if (categoryType == "contractor" && ContractorId == 0) {
      if (personName == "" || personName == null) {
        startErr = true
        this.setState({ personNameErr: "Please Enter Person Name" });
      }
      if (companyName == "" || companyName == null) {
        startErr = true
        this.setState({ companyNameErr: "Please Enter Company Name" });
      }
      if (contactNo == "" || contactNo == null) {
        startErr = true
        this.setState({ contactNoErr: "Please Enter Contact No." });
      }
      if (contactNo != "") {
        var contactNoError = mobileNoValidator(contactNo);
        if (contactNoError != "") {
          startErr = true
          this.setState({ contactNoErr: contactNoError });
        }
      }
      if (email == "" || email == null) {
        startErr = true
        this.setState({ emailErr: "Please enter Email" });
      }
      if (email != "") {
        var emailError = emailValidator(email);
        if (emailError != "") {
          startErr = true
          this.setState({ emailErr: emailError });
        }
      }
    }

    if (startErr) {
      toastError("Please enter mandaotry fields")
      return
    }

    // if (
    //   EntryDate != null &&
    //   (categoryType == "contractor" && ContractorId == 0
    //     ? companyName != "" &&
    //     personName != "" &&
    //     email != "" &&
    //     contactNo != "" &&
    //     emailErr == "" &&
    //     contactNoErr == ""
    //     : true)
    // ) {
    itemToCarryList.forEach((item) => {
      item.Name.trim()
      if (item.Name.trim() == "") {
        item.Nameerr = true;
      }
    });
    itemToCarryList.forEach((item) => {
      item.Name.trim()
      if (item.Quantity.trim() == "") {
        item.Quantityerr = true;
      }
    });
    this.setState({ itemToCarryList: itemToCarryList });
    const condition = itemToCarryList.some((item) => item.Name?.trim() == "");
    if (condition) {
      return toastError("Please fill all item names");
    }
    const condition2 = itemToCarryList.some(
      (item) => item.Quantity?.trim() == ""
    );
    if (condition2) {
      return toastError("Please fill quantity of all items");
    }
    var isDuplicate = false;
    for (var i = 0; i < itemToCarryList.length; i++) {
      for (var j = 0; j < itemToCarryList.length; j++) {
        console.log(
          itemToCarryList[i].Name == itemToCarryList[j].Name,
          itemToCarryList[i].Name,
          itemToCarryList[j].Name
        );
        if (i != j) {
          if (itemToCarryList[i].Name == itemToCarryList[j].Name) {
            isDuplicate = true;
            break;
          }
        }
      }
    }
    console.log(isDuplicate);
    if (isDuplicate) {
      toastError("Duplicate items names is not allowed");
      return;
    }
    if (
      categoryType == "contractor" &&
      (ContractorId == "Select" || ContractorId == null) &&
      RoleId != 7
    ) {
      toastError("Please select contractor");
      return;
    }
    if (noOfVehicles == '' || noOfVehicles == null || noOfVehicles < 1) {
      this.setState({
        noOfVehiclesErr: 'Please enter atleast 1 vehicle'
      })
      return toastError("Please enter atleast 1 vehicle");
    }
    if (noOfVehicles != '' && noOfVehicles != null) {
      // return toastError("Please fill Number of Verhicles");
      const condition3 = listOfVehicles.some((item) => item.driverName?.trim() == "");
      if (condition3) {
        return toastError("Please fill all driver names");
      }
      const condition4 = listOfVehicles.some((item) => item.type == '' || item.type == null);
      if (condition4) {
        return toastError("Please select all vehicle types");
      }
      const condition7 = listOfVehicles.some((item) => item.VehicleNo == '' || item.VehicleNo == null);
      if (condition7) {
        return toastError("Please fill all Vehicle No");
      }
      const condition5 = listOfVehicles.some((item) => item.driverNo == '' || item.driverNo == null);
      if (condition5) {
        return toastError("Please fill all driver mobile No");
      }
      const condition6 = listOfVehicles.some((item) => item.driverDocPath == '' && item.driverDocType == '');
      if (condition6) {
        return toastError("Please enter all driver documents");
      }
    }
    var tempcompanyName = "";
    var temppersonName = "";
    var tempcontactNo = "";
    var tempemail = "";
    if (ContractorId != null && ContractorId != 0) {
      contractorList.map((item) => {
        if (item.ContractorID == ContractorId) {
          tempcompanyName = item.CompanyName;
          temppersonName = item.PersonName;
          tempcontactNo = item.MobileNo;
          tempemail = item.EmailId;
        }
      });
    }
    if (RoleId == 7 && vendorBasicData) {
      tempcompanyName = vendorBasicData.CompanyName || "";
      temppersonName = `${vendorBasicData.PersonIncharge || ""} ${vendorBasicData.LastNamePersonIncharge || ""
        }`.trim();
      tempcontactNo = vendorBasicData.MobileNo || "";
      tempemail = vendorBasicData.PrimaryEmail || "";
    }
    // this.setState({ isLoading: true });
    const submitCategoryType =
      RoleId == 7 ? vendorBasicData?.CompanyName || "" : categoryType;
    console.log("exhibitorDetailsData--->", exhibitorDetailsData)
    this.props
      .submitExhibitorEntryPass_action(
        moment(EntryDate).format("YYYY-MM-DD"),
        submitCategoryType,
        ContractorId,
        tempcompanyName != "" ? tempcompanyName : companyName,
        temppersonName != "" ? temppersonName : personName,
        tempcontactNo != "" ? tempcontactNo : contactNo,
        tempemail != "" ? tempemail : email,
        itemToCarryList,
        isView ? ExhID : "",
        {
          person: exhibitorDetailsData?.["Contact Person"]
            ? exhibitorDetailsData?.["Contact Person"]
            : exhibitorDetailsData?.["Person Name"],
          PrimaryEmail: exhibitorDetailsData?.["PrimaryEmail"]
            ? exhibitorDetailsData?.["PrimaryEmail"]
            : exhibitorDetailsData?.["Email ID"],
          ExhibitionName: sessionStorage.getItem("ExhibitionName"),
        },
        mode, noOfVehicles, listOfVehicles
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.data.length > 0) {
            if (mode == 2) {
              toastSuccess("Entry pass submitted successfully!");
            } else {
              toastSuccess("Entry pass saved as draft successfully!");
            } this.getExhibitorEntryPassDetails();
            setTimeout(() => {
              this.setState({
                companyName: '',
                personName: '',
                contactNo: '',
                email: '',
                contactNoErr: '',
                // categoryType:
                //   sessionStorage.getItem("RoleIDSS") == 1
                //     ? "Exhibitor"
                //     : sessionStorage.getItem("RoleIDSS") == 7
                //       ? "contractor"
                //       : "contractor",
                itemToCarryList: [
                  { Name: "", Quantity: "", Nameerr: false, Quantityerr: false },
                ], listOfVehicles: [], noOfVehicles: '', tempMainListOfVehicles: []
              })
            }, 500);
            this.setState({ isLoading: false });
          }
          setTimeout(() => {
            if (isView) {
              this.props.navigate("/accountEntryPassList");
            }
          }, 1000);
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.log(err);
      });
    // } else {
    //   toastError("Please enter mandatory fields!");
    // }
  }

  getRandomLightColor() {
    const hue = Math.floor(Math.random() * 360); // any hue
    const saturation = 45 + Math.random() * 15; // 45–60% saturation (soft colors)
    const lightness = 78 + Math.random() * 7; // 78–85% lightness (slightly lighter)
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  handleInput = async (e, type, field, index) => {
    const updatedList = structuredClone(this.state.itemToCarryList);
    let Value;

    if (type === "date") {
      Value = e;
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "").replace(/^0+/, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    // --- Subcontractor level update ---
    updatedList[index][field] = Value;
    if (field == "Name") {
      updatedList[index].Nameerr = false;
    }
    if (field == "Quantity") {
      updatedList[index].Quantityerr = false;
    }

    this.setState({ itemToCarryList: updatedList });
  };

  handleInputEdit = async (e, type, field, index) => {
    const updatedList = structuredClone(this.state.editListItemsTocarry);
    let Value;

    if (type === "date") {
      Value = e;
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "").replace(/^0+/, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    // --- Subcontractor level update ---
    updatedList[index][field] = Value;
    if (field == "ItemName") {
      updatedList[index].Nameerr = false;
    }
    if (field == "Quantity") {
      updatedList[index].Quantityerr = false;
    }
    console.log(e, type, field, index, this.state.editListItemsTocarry)
    this.setState({ editListItemsTocarry: updatedList });
  };

  removeItem(index) {
    const { itemToCarryList } = this.state;
    const filterArray = itemToCarryList.filter((item, i) => i != index);
    if (filterArray.length == 0) {
      filterArray.push({
        Name: "",
        Quantity: "",
        Nameerr: false,
        Quantityerr: false,
      });
    }
    console.log("filterArray---->", filterArray);
    this.setState({ itemToCarryList: filterArray });
  }

  removeItemEdit(index) {
    const { editListItemsTocarry } = this.state;
    const filterArray = editListItemsTocarry.filter((item, i) => i != index);
    if (filterArray.length == 0) {
      filterArray.push({
        ItemName: "",
        Quantity: "",
        Nameerr: false,
        Quantityerr: false,
      });
    }
    console.log("filterArray---->", filterArray);
    this.setState({ editListItemsTocarry: filterArray });
  }


  getVendorBasicDetails() {
    const userId = JSON.parse(sessionStorage.getItem("loginDataSS")).UserID;
    this.props
      .getVendorBasicDetail_action(userId)
      .then((data) => {
        if (
          data.error != 1 &&
          data.data.vendorBasicDetail &&
          data.data.vendorBasicDetail.length > 0
        ) {
          const vendorData = data.data.vendorBasicDetail[0];
          this.setState({
            vendorBasicData: vendorData,
            exhibitorDetailsData: {
              ExhCompanyName: vendorData.CompanyName,
              "Contact Person": `${vendorData.PersonIncharge} ${vendorData.LastNamePersonIncharge}`,
              MobileNo: vendorData.MobileNo,
              PrimaryEmail: vendorData.PrimaryEmail,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  copyToClipboard = (UUID, i) => {
    const {
      isLoading,
      categoryType,
      copiedIndex,
      exhUUID,
      isCopied,
      isCopyModal,
      itemToCarryList,
      isView,
      exhibitorDetailsData,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      EntryDate,
      categoryList,
      isOpen,
      EntryDateErr,
      RoleId,
    } = this.state;
    console.log(UUID, i);
    const link = `${link_BASE_URL}entryPass/${UUID}/${sessionStorage.getItem(
      "sessionExhibitionID"
    )}/${exhUUID}`; // you can replace this

    // navigator.clipboard.writeText(link).then(() => {

    //     // reset message after 2 sec
    //     setTimeout(() => this.setState({ isCopied: false, copiedIndex: '' }), 2000);
    // });
    this.setState({ isCopied: true, copiedIndex: i });

    // const handleCopy = () => {
    const textArea = document.createElement("textarea");
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    // alert("Link copied!");
    setTimeout(() => this.setState({ isCopied: false, copiedIndex: "" }), 2000);

    // };
  };

  onPassDownload(id) {
    console.log(id);
    this.setState({ isLoading: true });
    this.props
      .getEntryPassPdf_action(id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          console.log("Proforma Pdf Download", data);
          var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const win = window.location.replace(url, "_blank");
          if (win != null) {
            win.focus();
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async onPassPrint(id) {
    console.log(id);
    this.setState({ isLoading: true });
    try {
      var list = [];
      const mapdata1 = {
        ParameterName: "@ExhEntryPassHdrID",
        ParameterValue: id,
        ParameterDataType: "int",
      };
      list.push(mapdata1);
      const mapData = {
        report_name: "EntryPass.rpt",
        parameter_details: list,
      };
      console.log("xxxxxxxxxxxxxxxxxxxxx", mapData);
      const res = await axiosPost(fetchAuthReport, mapData);
      this.setState({ isLoading: false });

      if (res != null) {
        var url = `${downloadReport}?SessionIdentifier=${res}`;
        const win = window.open(url, "_blank", "noopener,noreferrer");
        if (win != null) {
          win.focus();
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  onFilePick = async (e, file, i) => {
    e.preventDefault()
    const { exhibitDetailsList, tempFilePath, listOfVehicles } = this.state
    // console.log("File01010101------", file, key)
    const { } = this.state
    console.log(file, document.getElementById(`file${i}`), tempFilePath)
    if (file.length != 0) {
      if (file[0]['size'] >= 5 * 1024 * 1024) {
        toastError('File size more than 5mb are not allow.')
      } else {
        var image = '';
        if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
          file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
          file[0]['name'].toString().toLowerCase().includes('.png') ||
          file[0]['name'].toString().toLowerCase().includes('.jpg')
        ) {

          if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
          ) {
            image = await this.resizeFile(file[0]);
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            listOfVehicles[i].driverDocFile = image
            listOfVehicles[i].driverDocName = file[0]['name'].toString()
            //     visitorGroupList[i].passportFileErr = ''
            this.setState({ listOfVehicles: listOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
            // }

          }
          else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
            image = await this.onPdfSelect(file[0]);
            // if (key == 1) {
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            listOfVehicles[i].driverDocFile = image
            listOfVehicles[i].driverDocName = file[0]['name'].toString()
            this.setState({ listOfVehicles: listOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "" })
            // }
            // this.setState({ passportFile: image, passportFileErr: "" })

          }

          var fileType = file[0]['type']
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/")
          }
          // if (sessionStorage.getItem('VisitorTypeID') == 2) {
          //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          //     this.setState({ visitorGroupList: visitorGroupList })
          // } else {
          listOfVehicles[i].driverDocType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

          // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
          // }
        } else {
          toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

          // if (key == 1) {
          //     this.setState({ passportFile: "" })
          //     document.getElementById("passportFile").value = ""
          // } else if (key == 2) {
          //     this.setState({ visitorLetterFile: "" })
          //     document.getElementById("visitorLetter").value = ""
          // }
        }
      }
    } else {
      //     exhibitDetailsList[i].DocumentType = ''
      //     exhibitDetailsList[i].DocumentFile = ''
      //     exhibitDetailsList[i].DocumentName = ''
      //     this.setState({ exhibitDetailsList: exhibitDetailsList })
    }
  }

  // If Pdf is selected in file
  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  // File resize
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });

  onVehicleDocDelete(id, i) {
    const { isDel3Open, exhibitDetailsList, listOfVehicles } = this.state
    console.log(id)
    // if (!listOfVehicles[i].DocDeleted) {
    //   this.setState({ isDel3Open: !isDel3Open, delChapterID: id })
    // } else {
    listOfVehicles[i].driverDocType = ''
    listOfVehicles[i].driverDocFile = ''
    listOfVehicles[i].driverDocName = ''
    this.setState({ listOfVehicles: listOfVehicles })
    // }

  }

  onEditFilePick = async (e, file, i) => {
    e.preventDefault()
    const { exhibitDetailsList, editListOfVehicles, tempFilePath, listOfVehicles } = this.state
    // console.log("File01010101------", file, key)
    const { } = this.state
    console.log(file, document.getElementById(`file${i}`), tempFilePath)
    if (file.length != 0) {
      if (file[0]['size'] >= 5 * 1024 * 1024) {
        toastError('File size more than 5mb are not allow.')
      } else {
        var image = '';
        if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
          file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
          file[0]['name'].toString().toLowerCase().includes('.png') ||
          file[0]['name'].toString().toLowerCase().includes('.jpg')
        ) {

          if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
            file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
          ) {
            image = await this.resizeFile(file[0]);
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            editListOfVehicles[i].driverDocFile = image
            editListOfVehicles[i].driverDocName = file[0]['name'].toString()
            //     visitorGroupList[i].passportFileErr = ''
            this.setState({ editListOfVehicles: editListOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "", passPortFileName: file[0]['name'].toString() })
            // }

          }
          else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
            image = await this.onPdfSelect(file[0]);
            // if (key == 1) {
            // if (sessionStorage.getItem('VisitorTypeID') == 2) {
            editListOfVehicles[i].driverDocFile = image
            editListOfVehicles[i].driverDocName = file[0]['name'].toString()
            this.setState({ editListOfVehicles: editListOfVehicles })
            // } else {
            // this.setState({ passportFile: image, passportFileErr: "" })
            // }
            // this.setState({ passportFile: image, passportFileErr: "" })

          }

          var fileType = file[0]['type']
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/")
          }
          // if (sessionStorage.getItem('VisitorTypeID') == 2) {
          //     visitorGroupList[i].passportFileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          //     this.setState({ visitorGroupList: visitorGroupList })
          // } else {
          editListOfVehicles[i].driverDocType = fileTypeList.length > 0 ? fileTypeList[1] : ""
          // document.getElementById(`file${i}`).value = document.getElementById(`file${i}`).value

          // this.setState({ passportFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
          // }
        } else {
          toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')

          // if (key == 1) {
          //     this.setState({ passportFile: "" })
          //     document.getElementById("passportFile").value = ""
          // } else if (key == 2) {
          //     this.setState({ visitorLetterFile: "" })
          //     document.getElementById("visitorLetter").value = ""
          // }
        }
      }
    } else {
      //     exhibitDetailsList[i].DocumentType = ''
      //     exhibitDetailsList[i].DocumentFile = ''
      //     exhibitDetailsList[i].DocumentName = ''
      //     this.setState({ exhibitDetailsList: exhibitDetailsList })
    }
  }

  // If Pdf is selected in file
  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  // File resize
  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });

  onEditVehicleDocDelete(id, i) {
    const { isDel3Open, exhibitDetailsList, editListOfVehicles, listOfVehicles } = this.state
    console.log(id)
    if (!editListOfVehicles[i].driverDocdeleted) {
    }
    else {
      editListOfVehicles[i].driverDocType = ''
      editListOfVehicles[i].driverDocFile = ''
      editListOfVehicles[i].driverDocName = ''
      editListOfVehicles[i].driverDocPath = ''

      this.setState({ editListOfVehicles: editListOfVehicles })
    }

  }

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  onChangeEditNoOFVehicles(value) {
    const {
      editOpen, editIndex, editListOfVehicles, listOfVehicles,
      isLoading, deletePop, vehicleTypeList, editNoOfVehiclesErr, tempListOfVehicles,
      categoryType, noOfVehiclesErr, editNoOfVehicles } = this.state
    var tempList = []
    console.log('lllllllllllllllllllllllllllllllllllll', value)
    for (var i = 0; i < value; i++) {
      console.log(tempListOfVehicles[i])
      if (tempListOfVehicles[i] != undefined) {
        tempList.push(tempListOfVehicles[i])
      } else {
        tempList.push({ VehicleTypeID: '', DriverName: '', DriverMobNo: '', VehicleNo: '', driverDocFile: '', DriverDocument: '', EntryVehicleDtlID: '', driverDocName: '', driverDocType: '' })
      }
    }
    this.setState({ editListOfVehicles: tempList })
  }
  onChangeNoOFVehicles(value) {
    const {
      editOpen, editIndex, editListOfVehicles, listOfVehicles, mainListOfVehicles, tempMainListOfVehicles,
      isLoading, deletePop, vehicleTypeList, editNoOfVehiclesErr, tempListOfVehicles,
      categoryType, noOfVehiclesErr, editNoOfVehicles } = this.state
    var tempList = []
    console.log('lllllllllllllllllllllllllllllllllllll', tempMainListOfVehicles, value)
    for (var i = 0; i < value; i++) {
      console.log(tempMainListOfVehicles[i])
      if (tempMainListOfVehicles[i] != undefined) {
        tempList.push(tempMainListOfVehicles[i])
      } else {
        tempList.push({
          VehicleNo: '', type: '', driverName: '', driverNo: '', driverDocFile: '', driverDocPath: '', driverDocName: '', driverDocType: ''
        })
      }
    }
    this.setState({ listOfVehicles: tempList })
  }


  renderNewImage = (img, type) => {
    const { imageBase64 } = this.state;
    if (type == 'pdf') {
      // window.open(img, "_blank")

      const base64 = img;
      const pdfData = atob(base64.split(",")[1]); // decode Base64

      const len = pdfData.length;
      const uintArray = new Uint8Array(new ArrayBuffer(len));
      for (let i = 0; i < len; i++) {
        uintArray[i] = pdfData.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      window.open(url, "_blank"); // open in new tab

    } else {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(
          `<img src="${img}" style="width:100%;height:auto;" />`
        );
      } else {
        alert("Please allow popups for this website");
      }
    }
  };
  render() {
    const {
      editOpen, editIndex, editListOfVehicles, listOfVehicles,
      isLoading, deletePop, vehicleTypeList, editNoOfVehiclesErr,
      categoryType, noOfVehiclesErr, tempListOfVehicles,
      copiedIndex, editListItemsTocarry, tempMainListOfVehicles,
      isDirectContractor, isDelOpen,
      isCopied,
      exhUUID,
      isCopyModal,
      itemToCarryList, noOfVehicles, editNoOfVehicles,
      isView,
      exhibitorDetailsData,
      personName,
      personNameErr,
      companyName,
      companyNameErr,
      email,
      emailErr,
      contactNo,
      contactNoErr,
      contractorList,
      ContractorId,
      EntryDate,
      categoryList,
      isOpen,
      EntryDateErr,
      RoleId,
      stEntry,
      isVendor, isOpenConfirmationModal, mainListOfVehicles,
      showVideoModal, showEntryPass, exitPassMessage
    } = this.state;
    console.log(ContractorId == 0, ";", this.state.stEntry, categoryList, new Date());
    console.log(listOfVehicles, categoryList, editListOfVehicles, '][][]');

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}

        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />

        {RoleId == 1 ? (
          <ExhibitorHeader />
        ) : RoleId == 2 || RoleId == 6 || RoleId == 9 || RoleId == 7 ? (
          <HeaderWithLogo />
        ) : (
          <AdminHeader />
        )}

        {RoleId == 1 ? (
          <ExhibitorDrawer />
        ) : RoleId == 7 ? (
          <VendorDrawer />
        ) : (
          (RoleId == 2 || RoleId == 6 || RoleId == 9) && <AdminDrawer />
        )}



        {(isVendor == 1 || RoleId == 7 || RoleId == 1) && showVideoModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => this.setState({ showVideoModal: false })}>
            <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Entry Pass</h5>
                  <button type="button" className="btn-close" onClick={() => this.setState({ showVideoModal: false })}></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: '100%' }}>
                    <source src={RoleId == 1 ? "/assets/ExhibitorEntryPass.mp4" : "/assets/VendorEntryPass.mp4"} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="page">
          <div className={RoleId != 7 && RoleId != null && RoleId != 16 ? "with-dr-container" : ""}>
            {/* <div class="row m-0">
              {RoleId != 7 && (
                <div className="breadcrumb-scroll-fixed">
                  <h6 class="mb-0 p-2 text-white">
                    {isView
                      ? "Entry Pass"
                      : isDirectContractor
                        ? "Contractor Entry  Pass"
                        : "Exhibitor Entry Pass"}

                    {!isView && !isDirectContractor && isVendor != 1 && (
                      <span className="ml-auto link-option">
                        <a
                          style={{ cursor: "pointer" }}
                          onClick={() => this.setState({ isCopyModal: true })}
                          // onClick={() => window.open(`${window.location.origin}/#/exhibitorEntryPass`, '_blank', 'noopener,noreferrer')}
                          className="text-decoration-none text-primary"
                        >
                          Share Link to Contractor
                        </a>
                      </span>
                    )}
                  </h6>
                </div>
              )}
            </div> */}
            <div
              className={`main-content ${RoleId == 2 || RoleId == 7 || RoleId == 6 || RoleId == 9 || RoleId == 16
                ? "vendor-top-space"
                : RoleId == 1
                  ? "exb-top-space"
                  : ""
                }`}
              style={{ marginTop: RoleId == null ? '7.5rem' : '' }}
            >
              {RoleId == 1 && (
                <div className="">
                  <div className="row">
                    <ExhibitorTopMenu />
                  </div>
                </div>
              )}


              {showEntryPass ?
                <div className="text-center text-aqua">

                  {/* The entry pass will be enabled only after the organizer approves the No Dues Certificate. */}

                  <div className="container-fluid min-vh-90 d-flex justify-content-center align-items-center mt-5">
                    <div className="">

                      {/* Pending Icon */}
                      <div className="icon-wrapper mx-auto mb-3">
                        <svg
                          width="36"
                          height="36"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ffffff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="9" />
                          <path d="M12 7v5l3 3" />
                        </svg>

                      </div>

                      {/* Title */}
                      <h4 className="text-aqua mb-3 fw-semibold">
                        Awaiting Approval
                      </h4>

                      {/* Info Text */}
                      <h6 className="mb-0 text-center">
                        The entry pass will be enabled only after the 100% payment towards Space Booking
                      </h6>

                    </div>
                  </div>

                </div>
                :

                <section className="p-3 pt-0 text-left">
                  {(isVendor == 1 || RoleId == 7 || RoleId == 1) && (
                    <div className="d-flex justify-content-end mb-1 px-0 text-aqua pt-3 gap-2 mt-1 mt-lg-0">
                      {isVendor != 1 && (
                        <span
                          className="fw-bold"
                          onClick={() => this.setState({ isCopyModal: true })}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="text-decoration-none text-aqua fw-bold"></i>
                          Share Link to Contractor &nbsp; |&nbsp;
                        </span>
                      )}
                      <span
                        onClick={() => this.setState({ showVideoModal: true })}
                        style={{ cursor: 'pointer', color: '#3dbca7', fontSize: '16px' }}
                      >
                        <i className="bi bi-play-circle-fill me-2"></i>
                        User Manual
                      </span>
                    </div>
                  )}
                  <div className="row m-0">
                    <div className="col-md-8 p-0">
                      <div className="row py-2 pb-0">
                        <div className="col-md-4 mb-2">
                          <label className="text-muted d-block fw-normal">
                            {/* {RoleId == 7 || isVendor == 1
                            ? "Service Partner Name"
                            : "Exhibitor Name"} */}
                            Company Name
                          </label>
                          <span className="fw-semibold">
                            {exhibitorDetailsData?.["Exhibitor Details"] ||
                              exhibitorDetailsData?.["ExhCompanyName"]}
                          </span>
                        </div>
                        {console.log('exhibitorDetailsData', exhibitorDetailsData)}
                        {RoleId != 7 && isVendor != 1 && (
                          <div className="col-md-4 mb-2">
                            <label className="text-muted d-block fw-normal">
                              Hall No / Booth No
                            </label>
                            {exhibitorDetailsData["Hall No"] != null && exhibitorDetailsData["Hall No"] != '' && exhibitorDetailsData["Stall No"] != null && exhibitorDetailsData["Stall No"] != '' ?
                              <span className="fw-semibold">
                                {exhibitorDetailsData["Hall No"] != null && exhibitorDetailsData["Hall No"] != '' ? exhibitorDetailsData["Hall No"] : '-'} /{" "}
                                {exhibitorDetailsData["Stall No"] != null && exhibitorDetailsData["Stall No"] != '' ? exhibitorDetailsData["Stall No"] : '-'}
                              </span> : <span className="fw-semibold">-</span>}
                          </div>
                        )}
                        <div className="col-md-4 mb-2">
                          <label className="text-muted d-block fw-normal">
                            Contact Person
                          </label>
                          <span className="fw-semibold">
                            {exhibitorDetailsData?.["Person Name"] ||
                              exhibitorDetailsData?.["Contact Person"]}
                          </span>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="text-muted d-block fw-normal">
                            Mobile No
                          </label>
                          <span className="fw-semibold">
                            {exhibitorDetailsData?.["Mobile Number"] ||
                              exhibitorDetailsData?.["MobileNo"]}
                          </span>
                        </div>
                        <div className="col-md-4 mb-2">
                          <label className="text-muted d-block fw-normal">
                            Email
                          </label>
                          <span className="fw-semibold">
                            {exhibitorDetailsData?.["Email ID"] ||
                              exhibitorDetailsData?.["PrimaryEmail"]}
                          </span>
                        </div>
                      </div>
                    </div>
                    {RoleId != 7 && isVendor != 1 && (
                      <div className="col-md-4 text-center">
                        <img
                          src={
                            exhibitorDetailsData?.["isNodueIssued"] == 1
                              ? "images/no-dues-issued.png"
                              : "images/no-dues-pending.png"
                          }
                          className="img-responsive m-auto d-block mt-2 mb-2"
                          style={{ width: 150 }}
                        />
                      </div>
                    )}
                  </div>
                  {categoryList.length > 0 && (
                    <div className="row mx-0 mt-2">
                      <div className="entry-pass-row border rounded-2 bg-light p-2 mb-1">
                        <h6 className="entry-pass-title">Previous Entry Passes</h6>
                        <div className="p-0">
                          {/* <div className="select-details"> */}
                          {
                            categoryList.length > 0 &&
                            categoryList.map((item, i) => (
                              <div
                                className="accordion w-100"
                                id="entryAccordion"
                              >
                                <div className="accordion-item border-0">
                                  <h2
                                    className="accordion-header"
                                    id="headingOne"
                                    style={{ position: "relative" }}
                                  >
                                    <button
                                      className={editOpen ? editIndex == i ? "accordion-button d-flex align-items-center justify-content-between p-1 border rounded-0" : "accordion-button collapsed d-flex align-items-center justify-content-between p-1 border rounded-0" : "accordion-button collapsed d-flex align-items-center justify-content-between p-1 border rounded-0"}
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#collapseOne_${i}`}
                                      aria-expanded={editOpen ? editIndex == i ? true : false : false}
                                      aria-controls={`collapseOne_${i}`}
                                    >
                                      <div className="">
                                        <div className="align-items-center">
                                          <span className="text-muted d-flex d-md-inline px-2 border-end fw-bold">
                                            <i className="fa fa-calendar-o me-1 grid-icon" />
                                            {moment(item.EntryDate).format(
                                              "DD MMM YYYY"
                                            )}
                                          </span>
                                          <span
                                            className={
                                              categoryType === "contractor"
                                                ? "text-muted d-flex d-flex d-md-inline px-2 border-end pt-1"
                                                : "px-2 fw-normal"
                                            }
                                          >
                                            <i className="bi bi-door-closed-fill me-1 " />
                                            {/* Entry No: */}
                                            {item.EntryNo}
                                          </span>
                                          {categoryType === "contractor" && (
                                            <>
                                              <span className="text-muted px-2 d-flex d-md-inline fw-normal">
                                                <i className="ri-hotel-line me-1 text-dark" />
                                                {item.CompanyName}
                                              </span>
                                              {/* <span className="text-muted px-2 border-end fw-normal">
                                            <i className="ri-user-fill me-1 text-dark" />
                                            {item.PersonName}
                                          </span>
                                          <span className="text-muted px-2 border-end fw-normal">
                                            <i className="ri-phone-line me-1 text-dark" />
                                            {item.MobileNo}
                                          </span>
                                          <span className=" px-2 fw-normal">
                                            <i className="ri-mail-line me-1 text-dark" />
                                            {item.EmailID}
                                          </span> */}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                      {/* Action icons */}
                                    </button>
                                    {item.StatusID == 1 ? editIndex != i && <div className="d-flex">
                                      {/* <div> */}
                                      {/* <span className="text-muted px-2 border-end text-success">
                                                                Approved
                                                            </span> */}
                                      {/* </div> */}
                                      <div
                                        className="d-flex align-items-center  icon-header mb-1"
                                        style={{
                                          fontFamily: "sans-serif",
                                          scale: "0.6",
                                          marginTop: "-7px",
                                          right: "0px",
                                          zIndex: 0,
                                        }}

                                      >


                                        <button
                                          type="button"
                                          className="btn border-end"
                                          onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Update?', buttonName: 'Update', action: 0 }, popArg: [i, item.itemToCarryList, item.ExhEntryPassHdrID, item.EntryNo, JSON.parse(JSON.stringify(item.vehicleList)), item.NoOfVehicle, 2] })}
                                        // onClick={() =>
                                        //   this.setState({ editIndex: i, editListItemsTocarry: item.itemToCarryList, editEntryHdrId: item.ExhEntryPassHdrID, editEntryHdrNo: item.EntryNo }, () => this.updateExhibitorEntryPass(2))
                                        // }
                                        >
                                          <span class="material-symbols-outlined save-draft-icon" title="Submit">check_circle</span>
                                        </button>
                                        <button
                                          type="button"
                                          className="btn border-end mx-2"
                                          onClick={() =>
                                            this.setState({ editIndex: i, editOpen: true, editListItemsTocarry: item.itemToCarryList, editEntryHdrId: item.ExhEntryPassHdrID, editEntryHdrNo: item.EntryNo, editListOfVehicles: JSON.parse(JSON.stringify(item.vehicleList)), editNoOfVehicles: item.NoOfVehicle, tempListOfVehicles: JSON.parse(JSON.stringify(item.vehicleList)), mainListOfVehicles: JSON.parse(JSON.stringify(item.vehicleList)), }, () => console.log(item))
                                          }
                                        >
                                          <span class="material-symbols-outlined save-draft-icon" title="Edit">edit</span>
                                        </button>
                                        <button
                                          type="button"
                                          className="btn "
                                          onClick={() =>
                                            this.setState({ editListItemsTocarry: item.itemToCarryList, editEntryHdrId: item.ExhEntryPassHdrID, editEntryHdrNo: item.EntryNo }, () => this.setState({ deletePop: true }))
                                          }
                                        >
                                          <span class="material-symbols-outlined save-draft-icon" title="Delete">delete</span>
                                        </button>
                                      </div>
                                    </div> : <></>}
                                    {item.StatusID == 1 ? editIndex == i && <div className="d-flex">
                                      {/* <div> */}
                                      {/* <span className="text-muted px-2 border-end text-success">
                                                                Approved
                                                            </span> */}
                                      {/* </div> */}
                                      <div
                                        className="d-flex align-items-center  icon-header mb-1"
                                        style={{
                                          fontFamily: "sans-serif",
                                          scale: "0.6",
                                          marginTop: "-2px",
                                          // marginRight: '1rem'
                                          //  zIndex: rejectReasonModal ? 0 : 1
                                        }}
                                      ><button
                                        type="button"
                                        className="btn btn-warning mx-2"
                                        onClick={() => {

                                          item.vehicleList = this.state.mainListOfVehicles;
                                          item.NoOfVehicle = this.state.mainListOfVehicles.length
                                          this.setState({ vehicleList: this.state.vehicleList, }, () => {
                                            this.setState({
                                              editIndex: null, editOpen: false,
                                              // tempListOfVehicles: this.state.mainListOfVehicles 
                                            })
                                          })
                                        }
                                          //  () => {

                                        }
                                      >
                                          Cancel
                                        </button> </div></div> : <></>}

                                    {item.StatusID == 2 && <div className="d-flex align-items-center mx-2 icon-header" style={{ zIndex: 0 }}>
                                      <i
                                        title="Download Entry Pass"
                                        class="ri-download-line fs-6 grid-icon p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1"
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Download Entry Pass?', buttonName: 'Download', action: 1 }, popArg: [item.ExhEntryPassHdrID] })}
                                      // onClick={() =>
                                      //   this.onPassDownload(
                                      //     item.ExhEntryPassHdrID
                                      //   )
                                      // }
                                      ></i>
                                      <i
                                        title="Print Entry Pass"
                                        class="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-1 fw-normal border-end pe-2 me-1"
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to View Entry Pass?', buttonName: 'View', action: 2 }, popArg: [item.ExhEntryPassHdrID] })}
                                      // onClick={() =>
                                      //   this.onPassPrint(item.ExhEntryPassHdrID)
                                      // }
                                      ></i>
                                      <i
                                        className="fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-2 fw-normal qrIcon"
                                        title="Show QR code"
                                        onClick={() => {
                                          if (item.QRcodeImg) {
                                            const byteArray =
                                              item.QRcodeImg.data ||
                                              item.QRcodeImg;
                                            const base64 = btoa(
                                              String.fromCharCode(...byteArray)
                                            );
                                            this.setState({
                                              QrCodeImg: `data:image/png;base64,${base64}`,
                                              isOpen: true,
                                            });
                                          }
                                        }}
                                      />
                                    </div>}
                                  </h2>
                                  <div
                                    id={`collapseOne_${i}`}
                                    className={editOpen ? editIndex == i ? "accordion-collapse" : "accordion-collapse collapse" : "accordion-collapse collapse"}
                                    aria-labelledby="headingOne"
                                  >
                                    <div className="accordion-body p-0">
                                      {<h6 className="entry-pass-title mt-3">Vehicle Details</h6>}
                                      <label className="entry-pass-label">
                                        No. of Vehicles
                                      </label>
                                      <input
                                        type="number"
                                        disabled={editOpen ? editIndex == i ? false : true : true}
                                        className="form-control form-control-sm text-center mb-2"
                                        maxLength={10}
                                        style={{
                                          border:
                                            editNoOfVehiclesErr != '' && "1px solid red",
                                        }}
                                        value={editOpen ? editIndex == i ? editNoOfVehicles : item.NoOfVehicle : item.NoOfVehicle}
                                        onChange={(e) => e.target.value != '' && e.target.value != null ? /^[0-9]+$/.test(e.target.value) && this.setState({ editNoOfVehicles: parseInt(e.target.value), editNoOfVehiclesErr: '', }, () => this.onChangeEditNoOFVehicles(e.target.value))
                                          : this.setState({ editNoOfVehicles: '', editNoOfVehiclesErr: '', editListOfVehicles: [] })}
                                      />
                                      {editNoOfVehiclesErr != '' && (
                                        <span className="entry-pass-error">{editNoOfVehiclesErr}</span>
                                      )}
                                      {(editOpen ? editIndex == i ? (editNoOfVehicles != '' && editNoOfVehicles != null && editNoOfVehicles > 0) : (item.NoOfVehicle != '' && item.NoOfVehicle != null && item.NoOfVehicle > 0) : (item.NoOfVehicle != '' && item.NoOfVehicle != null && item.NoOfVehicle > 0)) &&
                                        <div className="table-responsive">
                                          <table className="table table-bordered table-sm mb-0">
                                            <thead className="table-light">
                                              <tr>
                                                <th style={{ width: 60, textAlign: "center" }}>
                                                  Sr. No.
                                                </th>
                                                <th style={{ width: 200, textAlign: "center" }}>
                                                  Vehicle type<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                </th>
                                                <th style={{ width: 200, textAlign: "center" }}>
                                                  Vehicle No<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                </th>
                                                <th >
                                                  Driver Name<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                </th>
                                                <th style={{ width: 200, textAlign: "center" }}>
                                                  Driver Mobile No.<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                </th>
                                                <th style={{ width: 150, textAlign: "center" }}>
                                                  Document<span className="text-red">{editOpen && editIndex == i && <span className="text-red">*</span>}</span>
                                                </th>
                                                {editOpen && editIndex == i && <th style={{ width: 60, textAlign: "center" }}>

                                                </th>}
                                              </tr>
                                            </thead>
                                            {editIndex == i ? <tbody>
                                              {editListOfVehicles.length > 0 ? (
                                                editListOfVehicles.map(
                                                  (item2, i) => (
                                                    <tr>
                                                      <td className="text-center">{i + 1}</td>
                                                      <td>
                                                        <select className="form-control text-center"
                                                          value={editListOfVehicles[i].VehicleTypeID}
                                                          // disabled
                                                          onChange={(e) => {
                                                            editListOfVehicles[i].VehicleTypeID = e.target.value;
                                                            this.setState({ editListOfVehicles: editListOfVehicles })
                                                          }}
                                                        >
                                                          <option value={''}>Select</option>
                                                          {
                                                            vehicleTypeList.length > 0 && vehicleTypeList.map((data) => (
                                                              <option key={data.VehicleTypeID} value={data.VehicleTypeID} >{data.VehicleTypeName}</option>
                                                            ))
                                                          }
                                                        </select>
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm w-100 px-1 w-100"
                                                          placeholder="Enter No."
                                                          maxLength={20}
                                                          onInput={(e) => this.maxLengthCheck(e, 20)}

                                                          // disabled
                                                          value={editListOfVehicles[i].VehicleNo}
                                                          onChange={(e) => {
                                                            editListOfVehicles[i].VehicleNo = e.target.value;
                                                            this.setState({ editListOfVehicles: editListOfVehicles })
                                                          }
                                                          }
                                                        />
                                                      </td>
                                                      <td >
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm w-100 px-1 w-100"
                                                          placeholder="Enter Name"
                                                          maxLength={200}
                                                          value={editListOfVehicles[i].DriverName}
                                                          onChange={(e) => {
                                                            editListOfVehicles[i].DriverName = e.target.value;
                                                            this.setState({ editListOfVehicles: editListOfVehicles })
                                                          }
                                                          }
                                                        // disabled
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="number"
                                                          className="form-control form-control-sm w-100 px-1 w-100"
                                                          placeholder="Enter No."
                                                          maxLength={10}
                                                          onInput={(e) => this.maxLengthCheck(e, 10)}

                                                          // disabled
                                                          value={editListOfVehicles[i].DriverMobNo}
                                                          onChange={(e) => {
                                                            editListOfVehicles[i].DriverMobNo = e.target.value;
                                                            this.setState({ editListOfVehicles: editListOfVehicles })
                                                          }
                                                          }
                                                        />
                                                      </td>
                                                      <td style={{ width: '', position: 'relative' }}>
                                                        {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                                        {editListOfVehicles[i].driverDocName != '' && editListOfVehicles[i].driverDocName != null ? <div style={{
                                                          border: '1px solid #ccc',
                                                          padding: '10px',
                                                          display: 'inline-flex',
                                                          alignItems: 'center',
                                                          // marginTop: '10px'
                                                        }}>
                                                          {editListOfVehicles[i].driverDocdeleted == false ? <a
                                                            href={editListOfVehicles[i].driverDocPath}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                          >
                                                            <span style={{ marginRight: '10px' }}
                                                            >{editListOfVehicles[i].driverDocName}</span>
                                                          </a> : <span onClick={() => this.renderNewImage(editListOfVehicles[i].driverDocFile, editListOfVehicles[i].driverDocType)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                          >{editListOfVehicles[i].driverDocName}</span>}                                                            <i className={`fa fa-times text-danger img-can`}
                                                            onClick={(e) => this.setState({ isDelOpen: true, delID: editListOfVehicles[i].EntryVehicleDtlID })}
                                                          ></i>
                                                        </div>
                                                          : <div className="upload-options mt-1">

                                                            <input
                                                              type="file"
                                                              id={`file${i}`}
                                                              ref={this.fileInputRef}
                                                              name={`file${i}`}
                                                              style={{ display: 'none' }}
                                                              className="image-upload"
                                                              accept=".jpg, .jpeg, .png, .pdf"
                                                              onChange={e => this.onEditFilePick(e, e.target.files, i)}
                                                            />

                                                            <button
                                                              type="button"
                                                              className="btn btn-primary"
                                                              onClick={() => document.getElementById(`file${i}`).click()}
                                                            >
                                                              {editListOfVehicles[i].VehicleTypeID != '' && editListOfVehicles[i].VehicleTypeID != null ? editListOfVehicles[i].VehicleTypeID == 1 ? 'Upload Driving Licence' : 'Upload any Government proof' : 'Upload document'}
                                                            </button>

                                                            {this.state.fileName && (
                                                              <span className="selected-file-name">{this.state.fileName}</span>
                                                            )}

                                                          </div>}
                                                      </td>
                                                      <td style={{ width: '', position: 'relative' }}>
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm"
                                                          onClick={(e) => {
                                                            tempListOfVehicles.splice(i, 1);
                                                            editListOfVehicles.splice(i, 1);
                                                            this.setState({ tempListOfVehicles: tempListOfVehicles, editListOfVehicles: editListOfVehicles, editNoOfVehicles: editNoOfVehicles - 1 })
                                                          }
                                                          }
                                                        >
                                                          <i className="bi bi-trash text-danger" />
                                                        </button>
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr className="text-center">
                                                  <td>Record not found</td>
                                                </tr>
                                              )}
                                            </tbody> : <tbody>
                                              {item.vehicleList.length > 0 ? (
                                                item.vehicleList.map(
                                                  (item2, i) => (
                                                    <tr>
                                                      <td className="text-center">{i + 1}</td>
                                                      <td>
                                                        <select className="form-control text-center"
                                                          value={item2.VehicleTypeID}
                                                          disabled
                                                        // onChange={(e) => {
                                                        //   listOfVehicles[i].type = e.target.value;
                                                        //   this.setState({ listOfVehicles: listOfVehicles })
                                                        // }}
                                                        >
                                                          <option value={''}>Select</option>
                                                          {
                                                            vehicleTypeList.length > 0 && vehicleTypeList.map((data) => (
                                                              <option key={data.VehicleTypeID} value={data.VehicleTypeID} >{data.VehicleTypeName}</option>
                                                            ))
                                                          }
                                                        </select>
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                                          placeholder="Vehicle No."
                                                          maxLength={20}
                                                          disabled
                                                          value={item2.VehicleNo}
                                                        // onChange={(e) => {
                                                        //   listOfVehicles[i].driverNo = e.target.value;
                                                        //   this.setState({ listOfVehicles: listOfVehicles })
                                                        // }
                                                        // }
                                                        />
                                                      </td>
                                                      <td >
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm w-100 px-1 w-100"
                                                          placeholder="Enter Name"
                                                          maxLength={200}
                                                          value={item2.DriverName}
                                                          // onChange={(e) => {
                                                          //   listOfVehicles[i].driverName = e.target.value;
                                                          //   this.setState({ listOfVehicles: listOfVehicles })
                                                          // }
                                                          // }
                                                          disabled
                                                        />
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="number"
                                                          className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                                          placeholder="Driver mob No."
                                                          maxLength={20}
                                                          disabled
                                                          value={item2.DriverMobNo}
                                                        // onChange={(e) => {
                                                        //   listOfVehicles[i].driverNo = e.target.value;
                                                        //   this.setState({ listOfVehicles: listOfVehicles })
                                                        // }
                                                        // }
                                                        />
                                                      </td>
                                                      <td style={{ width: '', position: 'relative' }}>
                                                        {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                                        {item2.driverDocName != '' && item2.driverDocName != null && item2.driverDocName != undefined ? <div style={{
                                                          border: '1px solid #ccc',
                                                          padding: '10px',
                                                          display: 'inline-flex',
                                                          alignItems: 'center',
                                                          // marginTop: '10px'
                                                        }}>
                                                          <a
                                                            href={item2.driverDocPath}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                          >
                                                            <span style={{ marginRight: '10px' }}
                                                            >{item2.driverDocName}</span>
                                                          </a>
                                                          {/* <i className={`fa fa-times text-danger img-can`}
                                                          onClick={(e) => this.onVehicleDocDelete(item.EntryVehicleDtlID, i)}
                                                          ></i> */}
                                                        </div>
                                                          : <div style={{
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            // marginTop: '10px'
                                                          }}>
                                                            {/* <a
                                                                // href={item2.driverDocPath}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                              > */}

                                                            <span style={{ marginRight: '10px', color: 'red' }}
                                                            >  (Please upload Document)</span>
                                                            {/* </a> */}

                                                          </div>
                                                        }
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr className="text-center">
                                                  <td>Record not found</td>
                                                </tr>
                                              )}
                                            </tbody>}
                                          </table>
                                        </div>}
                                      <hr />
                                      {<h6 className="entry-pass-title">Items to Carry Details</h6>}

                                      <div className="card-body p-1">
                                        <div className="d-flex justify-content-between align-items-center pt-0 pb-1"></div>
                                        <div className="table-responsive">
                                          <table className="table table-bordered table-sm mb-0">
                                            <thead className="table-light">
                                              <tr>
                                                <th
                                                  style={{
                                                    width: 60,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Sr. No.
                                                </th>
                                                <th>Item Name{editOpen && editIndex == i && <span className="text-red">*</span>}</th>
                                                <th
                                                  style={{
                                                    width: 80,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Qty{editOpen && editIndex == i && <span className="text-red">*</span>}
                                                </th>
                                                {editOpen && editIndex == i && <th style={{ width: 60, textAlign: "center" }}></th>}
                                              </tr>
                                            </thead>
                                            {editIndex == i ? <tbody>
                                              {editListItemsTocarry.length > 0 ? (
                                                editListItemsTocarry.map(
                                                  (data, index) => (
                                                    <tr>
                                                      <td className="text-center">
                                                        {index + 1}
                                                      </td>
                                                      <td>
                                                        <input
                                                          type="text"
                                                          style={{
                                                            border:
                                                              item.Nameerr && "1px solid red",
                                                          }}
                                                          className="form-control form-control-sm w-100 px-1"
                                                          placeholder="Enter item"
                                                          maxLength={200}
                                                          value={data.ItemName}
                                                          disabled={editOpen ? editIndex == i ? false : true : true}
                                                          onChange={(e) =>
                                                            this.handleInputEdit(
                                                              e,
                                                              "varchar",
                                                              "ItemName",
                                                              index
                                                            )
                                                          }
                                                        />
                                                        {/* {data.ItemName} */}
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm w-100 text-center"
                                                          maxLength={10}
                                                          style={{
                                                            border:
                                                              item.Quantityerr && "1px solid red",
                                                          }}
                                                          value={data.Quantity}
                                                          disabled={editOpen ? editIndex == i ? false : true : true}
                                                          onChange={(e) =>
                                                            this.handleInputEdit(
                                                              e,
                                                              "int",
                                                              "Quantity",
                                                              index
                                                            )
                                                          }
                                                        />
                                                        {/* {data.Quantity} */}
                                                      </td>
                                                      {editOpen && editIndex == i && <td className="text-center">
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm"
                                                          onClick={(e) => this.removeItemEdit(index)}
                                                        >
                                                          <i className="bi bi-trash text-danger" />
                                                        </button>
                                                      </td>}
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr className="text-center">
                                                  <td>Record not found</td>
                                                </tr>
                                              )}
                                            </tbody> : <tbody>
                                              {item.itemToCarryList.length > 0 ? (
                                                item.itemToCarryList.map(
                                                  (data, index) => (
                                                    <tr>
                                                      <td className="text-center">
                                                        {index + 1}
                                                      </td>
                                                      <td>
                                                        <input
                                                          type="text"
                                                          style={{
                                                            border:
                                                              item.Nameerr && "1px solid red",
                                                          }}
                                                          className="form-control form-control-sm w-100 px-1"
                                                          placeholder="Enter item"
                                                          maxLength={200}
                                                          value={data.ItemName}
                                                          disabled={editOpen ? editIndex == i ? false : true : true}
                                                          onChange={(e) =>
                                                            this.handleInput(
                                                              e,
                                                              "varchar",
                                                              "Name",
                                                              i
                                                            )
                                                          }
                                                        />
                                                        {/* {data.ItemName} */}
                                                      </td>
                                                      <td className="text-center">
                                                        <input
                                                          type="text"
                                                          className="form-control form-control-sm w-100 text-center"
                                                          maxLength={10}
                                                          style={{
                                                            border:
                                                              item.Quantityerr && "1px solid red",
                                                          }}
                                                          value={data.Quantity}
                                                          disabled={editOpen ? editIndex == i ? false : true : true}
                                                          onChange={(e) =>
                                                            this.handleInput(
                                                              e,
                                                              "int",
                                                              "Quantity",
                                                              i
                                                            )
                                                          }
                                                        />
                                                        {/* {data.Quantity} */}
                                                      </td>
                                                      {editOpen && editIndex == i && <td className="text-center">
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm"
                                                          onClick={(e) => this.removeItem(i)}
                                                        >
                                                          <i className="bi bi-trash text-danger" />
                                                        </button>
                                                      </td>}
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr className="text-center">
                                                  <td>Record not found</td>
                                                </tr>
                                              )}
                                            </tbody>}
                                          </table>
                                        </div>
                                        {editOpen && editIndex == i && <button
                                          type="button"
                                          className="btn btn-blue-border m-2"
                                          onClick={() => {
                                            const updatedList = [...this.state.editListItemsTocarry];
                                            updatedList.push({
                                              ItemName: "",
                                              Quantity: "",
                                              Nameerr: false,
                                              Quantityerr: false,
                                            });
                                            this.setState({ editListItemsTocarry: updatedList });
                                          }}
                                        >
                                          <i className="bi bi-plus-circle me-1" /> Add More
                                          Items
                                        </button>}

                                      </div>
                                      {editOpen && editIndex == i && <div className="row mb-2">
                                        <div className="col d-flex justify-content-end">
                                          <button
                                            style={{ backgroundColor: '#51cbc0' }}
                                            type="button"
                                            className="btn text-white  mr-2"
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Save as Draft?', buttonName: ' Save As Draft', action: 3 }, popArg: [1] })}
                                          // onClick={() => this.updateExhibitorEntryPass(1)}
                                          >
                                            Save As Draft
                                          </button>
                                          <button
                                            style={{ backgroundColor: '#51cbc0' }}
                                            type="button"
                                            className="btn text-white ms-2"
                                            onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 4 }, popArg: [2] })}
                                          // onClick={() => this.updateExhibitorEntryPass(2)}
                                          >
                                            Submit
                                          </button>
                                        </div>
                                      </div>}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                            // :                                        <div className="text-left">Record not found</div>
                          }
                          {/* </div> */}
                        </div>
                      </div>

                    </div>
                  )}

                  <div className="entry-pass-row border rounded-2 bg-light p-2 mb-1">
                    <h6 className="entry-pass-title">New Entry Pass</h6>

                    <div className="entry-pass-card mt-2">
                      <div className="entry-pass-field">
                        <label className="entry-pass-label">
                          <i className="fa fa-calendar entry-pass-icon grid-icon"></i>
                          Entry Date <span className="entry-pass-required">*</span>
                        </label>

                        <DatePicker
                          selected={EntryDate != '' && EntryDate != null ? new Date(EntryDate) : ''}
                          dateFormat="dd/MM/yyyy"
                          className={`entry-pass-input form-control ${EntryDateErr ? "entry-pass-input-error form-control" : ""
                            }`}
                          onChange={(date) =>
                            this.setState({ EntryDate: date, EntryDateErr: "" })
                          }
                          minDate={this.state.setupDate != '' && this.state.setupDate != null ? new Date(this.state.setupDate) : ''}
                          maxDate={this.state.dismantleDate != '' && this.state.dismantleDate != null ? new Date(this.state.dismantleDate) : ''}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="DD / MM / YYYY"
                        />

                        {EntryDateErr && (
                          <span className="entry-pass-error">{EntryDateErr}</span>
                        )}
                      </div>
                    </div>
                    {!isDirectContractor && RoleId != 7 && isVendor != 1 && (
                      <div className="row">
                        <div className="form-group py-3 pt-1 pb-2 m-0">
                          <label className="form-label d-block mb-2">
                            Select Category
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input mt-1"
                              type="radio"
                              name="userType"
                              id="exhibitor"
                              checked={categoryType == "Exhibitor"}
                              disabled={isView && stEntry == "Contractor"}
                              onChange={() =>
                                this.setState(
                                  { categoryType: "Exhibitor", ContractorId: null },
                                  () => {
                                    this.getExhibitorEntryPassDetails();
                                    this.handleClearErr();
                                  }
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exhibitor"
                            >
                              Exhibitor
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input mt-1"
                              type="radio"
                              name="userType"
                              disabled={isView && stEntry == "Contractor"}
                              id="contractor"
                              checked={categoryType == "contractor"}
                              onChange={() =>
                                this.setState(
                                  {
                                    categoryType: "contractor",
                                    ContractorId: null,
                                    categoryList: [],
                                  },
                                  () => {
                                    this.handleClearErr();
                                  }
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="contractor"
                            >
                              Contractor
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    {categoryType === "contractor" &&
                      RoleId != 7 &&
                      isVendor != 1 && (
                        <div class="row pb-3">
                          <div className="col-xl-3">
                            <select
                              className={
                                isDirectContractor
                                  ? "form-control  mt-3"
                                  : "form-control"
                              }
                              value={ContractorId}
                              disabled={
                                (isView && stEntry == "Contractor") ||
                                isDirectContractor
                              }
                              onChange={(e) =>
                                this.setState(
                                  {
                                    ContractorId:
                                      e.target.value != "Select"
                                        ? parseInt(e.target.value)
                                        : "Select",
                                  },
                                  () => {
                                    if (e.target.value != "Select") {
                                      !isView &&
                                        this.getExhibitorEntryPassDetails();
                                    } else {
                                      this.setState({ categoryList: [] });
                                    }
                                    this.handleClearErr();
                                  }
                                )
                              }
                            >
                              <option value={"Select"}>Select</option>
                              {contractorList.length > 0 &&
                                contractorList.map((data) => (
                                  <option
                                    key={data.ContractorID}
                                    value={data.ContractorID}
                                  >
                                    {data.ContractorID == 0 ? data.CompanyName : `${data.CompanyName}-${data.Service}`}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      )}
                    {ContractorId === 0 && (
                      <div class="row pb-3">
                        <div className="col-xl-3">
                          <label htmlFor="validationCustom03">
                            Person Name<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={personName}
                            disabled={isView && stEntry == "Contractor"}
                            maxLength={100}
                            onChange={(e) =>
                              this.setState({
                                personName: e.target.value.replace(
                                  /[^a-zA-Z ]/g,
                                  ""
                                ),
                                personNameErr: "",
                              })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {personNameErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-3">
                          <label htmlFor="validationCustom03">
                            Company Name<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={companyName}
                            disabled={isView && stEntry == "Contractor"}
                            maxLength={200}
                            onChange={(e) =>
                              this.setState({
                                companyName: e.target.value,
                                companyNameErr: "",
                              })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {companyNameErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-3">
                          <label htmlFor="validationCustom03">
                            Contact No<span className="text-red">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={contactNo}
                            disabled={isView && stEntry == "Contractor"}
                            // maxLength={countryId == 91 ? 10 : 20}
                            maxLength={10}
                            // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                            onInput={(e) => this.maxLengthCheck(e, 10)}
                            // onKeyDown={(e) => this.preventMinus(e)}
                            onWheel={(e) => e.target.blur()}
                            onPaste={(e) => this.handlePaste(e)}
                            onChange={(e) =>
                              this.setState({
                                contactNo: e.target.value.replace(/\D/g, ""),
                                contactNoErr: "",
                              })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {contactNoErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-3">
                          <label htmlFor="validationCustom03">
                            Email ID<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={email}
                            maxLength={100}
                            disabled={isView && stEntry == "Contractor"}
                            onChange={(e) =>
                              this.setState({ email: e.target.value, emailErr: "" })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {emailErr}
                            </span>
                          }
                        </div>
                      </div>
                    )}
                    <div className="select-details">
                      <div className="row mx-0 mt-2">
                        <div className="card shadow-none rounded-3 mb-0 border p-0 mb-3">
                          <div className="card-header  text-dark py-2 bg-card-header">
                            <i className="bi bi-exclamation-circle-fill grid-icon me-2" />
                            Important Notes
                          </div>
                          <div className="card-body py-1 p-0">
                            <ol className="mb-0" style={{ listStyleType: 'none' }}>
                              <li>
                                <strong>Step 1: Collect the Possession Letter</strong>
                                <p>
                                  Exhibitors, Exhibitor Representatives, or Stand Contractors (E/ER/SC) who come to IEML with exhibits or stand fabrication materials require a copy of participation letters & need to park their trucks at the NASA Parking lot in Knowledge Park III, where all freight trucks and stand contractors must report.
                                </p>
                              </li>

                              <li className="mb-3">
                                <strong>Step 2: Collection of No Dues Certificate & Wristband</strong>
                                <p>
                                  Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) of the same exhibit/stand fabrication material shall report to the India ITME 2026 Site office (IEML Venue, Gate No. X):
                                </p>

                                <p style={{ textIndent: '20px' }} className="my-0"><strong>The following tasks have to be completed at the site office before stall possession:</strong></p>

                                <ul className="mt-0">
                                  <li>a) Submit the participation letter or Authorisation letter issued by the exhibitor to the Stand Contractor.</li>
                                  <li>b) Submit the Demand Draft (DD) in favour of India ITME Society (for bare space exhibitors/contractors).</li>
                                  <li>c) Collect two copies of the No Dues Certificate, along with the Contractor wristband.</li>
                                  <li>d) <strong>The Exhibitor Kit will be handed over exclusively to the Exhibitor.</strong></li>
                                </ul>
                              </li>

                              <li>
                                <strong>Step 3: Hall & Location Confirmation</strong>
                                <p>
                                  After collecting the No Dues Certificate, the Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) will approach their respective freight forwarder agency and the Hall Manager in the relevant hall to confirm their allotted location.
                                </p>
                              </li>

                              <li>
                                <strong>Step 4: Proceed to the NASA Parking Area</strong>

                                <p className="my-0">
                                  Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) will show a No Dues certificate and a Material Entry Pass to the Hall Manager or Security Personnel at the NASA Parking area.
                                </p>
                                <p className="my-0">
                                  A truck gate pass (Hall Number Wise Token). will be issued, and the same sticker will be placed on the truck’s windshield glass.
                                </p>
                                <p className="mt-0">
                                  Upon entering the IEML venue and proceeding to the designated hall, the Exhibitor / Exhibitor Representative / Stand Contractor (E/ER/SC) and on-site management and Security personnel will guide the vehicle to the correct Hall location                                </p>
                              </li>

                              <li className="mb-3">
                                <strong>Step 5: Entry into IEML Venue</strong>

                                <p style={{ textIndent: '20px' }} className="my-0"><strong>Proceed to the designated freight entry gate of the IEML venue.</strong></p>
                                <p className="my-0">At the venue gate:</p>
                                <ul style={{ listStyleType: 'disc' }}>
                                  <li>Security will scan the No Dues Certificate and Material Entry Pass.</li>
                                  <li>After clearance, proceed to the freight entry gate of the allocated hall, show the No Dues certificate and Material Entry Pass to security at the respective gate. </li>
                                </ul>
                              </li>

                              <li>
                                <strong>Step 6: Entry into the Exhibition Hall & Booth Possession</strong>

                                <p>
                                  Please show the No Dues Certificate to the   <strong>“Hall Manager”</strong>, who will scan it again, and hand over possession of your Booth.
                                </p>
                              </li>

                              <li>
                                <strong>Step 7: Empty Vehicle Move-Out (After Offloading)</strong>
                                <p style={{ textIndent: '20px' }} className="my-0"><strong>The following tasks must be completed:</strong></p>
                                <ul style={{ listStyleType: 'disc' }}>
                                  <li>Once offloading is completed, empty vehicles shall proceed towards the exit of the exhibition hall.</li>
                                  <li>The Material Entry Pass will be scanned by the security at the Hall Exit Gate and again at the main Venue Gate.</li>
                                </ul>

                              </li>

                            </ol>

                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="card shadow-none rounded-3 mb-0 border p-0">
                          <div className="card-header  text-dark py-2 bg-card-header">
                            <i className="bi bi-car-front-fill me-2 grid-icon" />
                            Vehicle details
                          </div>
                          <div className="card-body px-2 pt-1 pb-2">
                            <div className="entry-pass-field">
                              <label className="entry-pass-label">
                                No. of Vehicles
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm text-center"
                                maxLength={10}
                                style={{
                                  border:
                                    noOfVehiclesErr != '' && "1px solid red",
                                }}
                                value={noOfVehicles}
                                onChange={(e) => e.target.value != '' && e.target.value != null ? /^[0-9]+$/.test(e.target.value) && this.setState({ noOfVehicles: parseInt(e.target.value), noOfVehiclesErr: '', tempMainListOfVehicles: listOfVehicles.length != 0 ? JSON.parse(JSON.stringify(listOfVehicles)) : this.state.tempMainListOfVehicles }, () => {
                                  setTimeout(() => {
                                    this.onChangeNoOFVehicles(e.target.value)
                                  }, 100);
                                })
                                  : this.setState({ noOfVehicles: '', noOfVehiclesErr: '', tempMainListOfVehicles: listOfVehicles.length != 0 ? JSON.parse(JSON.stringify(listOfVehicles)) : this.state.tempMainListOfVehicles }, () => {
                                    // this.setState({ listOfVehicles: [],})
                                    this.onChangeNoOFVehicles(e.target.value)
                                  })}
                              />
                              {noOfVehiclesErr != '' && (
                                <span className="entry-pass-error">{noOfVehiclesErr}</span>
                              )}
                            </div>
                            {listOfVehicles.length > 0 && <p className="fw-semibold mb-0">
                              Please Enter the Details of the Driving Person:
                            </p>}
                            {listOfVehicles.length > 0 && <div className="table-responsive ">
                              <table
                                className="table table-bordered table-sm mb-2"
                                id="itemsTable1"
                              >
                                <thead className="table-light">
                                  <tr>
                                    <th style={{ width: 60, textAlign: "center" }}>
                                      Sr. No.
                                    </th>
                                    <th style={{ width: 200, textAlign: "center" }}>
                                      Vehicle type<span className="text-red">*</span>
                                    </th>
                                    <th style={{ width: 200, textAlign: "center" }}>
                                      Vehicle No.<span className="text-red">*</span>
                                    </th>
                                    <th >
                                      Driver Name<span className="text-red">*</span>
                                    </th>
                                    <th style={{ width: 200, textAlign: "center" }}>
                                      Driver Mobile No.<span className="text-red">*</span>
                                    </th>
                                    <th style={{ width: 150, textAlign: "center" }}>
                                      Document<span className="text-red">*</span>
                                    </th>
                                    <th style={{ width: 60, textAlign: "center" }}>
                                      {/* <span className="text-red">*</span> */}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {listOfVehicles.length > 0 &&
                                    listOfVehicles.map((item, i) => (
                                      <tr>
                                        <td className="text-center">{i + 1}</td>
                                        <td>
                                          <select className="form-control text-center"
                                            value={item.type}
                                            onChange={(e) => {
                                              listOfVehicles[i].type = e.target.value;
                                              this.setState({ listOfVehicles: listOfVehicles })
                                            }}
                                          >
                                            <option value={''}>Select</option>
                                            {
                                              vehicleTypeList.length > 0 && vehicleTypeList.map((data) => (
                                                <option key={data.VehicleTypeID} value={data.VehicleTypeID} >{data.VehicleTypeName}</option>
                                              ))
                                            }
                                          </select>
                                          {/* <input
                                            type="text"
                                            style={{
                                              border:
                                                item.Nameerr && "1px solid red",
                                            }}
                                            className="form-control form-control-sm w-100 px-1 w-100"
                                            placeholder="Enter item"
                                            maxLength={200}
                                            value={item.Name}
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "Name",
                                                i
                                              )
                                            }
                                          /> */}
                                        </td>
                                        <td className="text-center">
                                          <input
                                            type="text"
                                            className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                            placeholder="Vehicle No."
                                            onInput={(e) => this.maxLengthCheck(e, 20)}
                                            maxLength={20}
                                            value={item.VehicleNo}
                                            onChange={(e) => {
                                              listOfVehicles[i].VehicleNo = e.target.value;
                                              this.setState({ listOfVehicles: listOfVehicles })
                                            }
                                            }
                                          />
                                        </td>
                                        <td >
                                          <input
                                            type="text"
                                            className="form-control form-control-sm w-100 px-1 w-100"
                                            placeholder="Driver Name"
                                            maxLength={200}
                                            value={item.driverName}
                                            onChange={(e) => {
                                              listOfVehicles[i].driverName = e.target.value;
                                              this.setState({ listOfVehicles: listOfVehicles })
                                            }
                                            }
                                          />
                                        </td>
                                        <td className="text-center">
                                          <input
                                            type="number"
                                            className="form-control form-control-sm w-100 px-1 w-100 text-center"
                                            placeholder="Driver mob No."
                                            onInput={(e) => this.maxLengthCheck(e, 10)}
                                            maxLength={10}
                                            value={item.driverNo}
                                            onChange={(e) => {
                                              listOfVehicles[i].driverNo = e.target.value;
                                              this.setState({ listOfVehicles: listOfVehicles })
                                            }
                                            }
                                          />
                                        </td>
                                        <td style={{ width: '', position: 'relative' }}>
                                          {/* {(data.isMachine || data.IsAccessory) && <span className="text-red" style={{ top: '-5px', right: '0px', fontSize: '20px' }}>*</span>} */}
                                          {item.driverDocName != '' ? <div style={{
                                            border: '1px solid #ccc',
                                            padding: '10px',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            // marginTop: '10px'
                                          }}>
                                            {/* {console.log(this.state.isSSifile)} */} <a
                                              href={item.driverDocPath}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <span style={{ marginRight: '10px' }}
                                              >{item.driverDocName}</span>
                                            </a>
                                            <i className={`fa fa-times text-danger img-can`}
                                              onClick={(e) => this.onVehicleDocDelete(item.EntryVehicleDtlID, i)}
                                            ></i>
                                          </div>
                                            : <div className="upload-options mt-1">

                                              <input
                                                type="file"
                                                id={`file${i}`}
                                                ref={this.fileInputRef}
                                                name={`file${i}`}
                                                style={{ display: 'none' }}
                                                className="image-upload"
                                                accept=".jpg, .jpeg, .png, .pdf"
                                                onChange={e => this.onFilePick(e, e.target.files, i)}
                                              />

                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => document.getElementById(`file${i}`).click()}
                                              >
                                                {item.type != '' && item.type != null ? item.type == 1 ? 'Upload Driving Licence' : 'Upload any Government proof' : 'Upload document'}
                                              </button>

                                              {
                                                item.driverDocFile !== "" &&
                                                <i
                                                  className="fa fa-times text-danger img-can"
                                                  onClick={() => this.onCrossClick(i)}
                                                ></i>
                                              }

                                            </div>}
                                        </td>
                                        <td style={{ width: '', position: 'relative' }}>
                                          <button
                                            type="button"
                                            className="btn btn-sm"
                                            onClick={(e) => {
                                              tempMainListOfVehicles.splice(i, 1);
                                              listOfVehicles.splice(i, 1);
                                              this.setState({ tempMainListOfVehicles: tempMainListOfVehicles, listOfVehicles: listOfVehicles, noOfVehicles: noOfVehicles - 1 })
                                            }
                                            }
                                          >
                                            <i className="bi bi-trash text-danger" />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>}
                          </div>
                        </div>
                      </div>
                      <div className="row mx-0">
                        <div className="card shadow-none rounded-3 mb-0 border p-0">
                          <div className="card-header  text-dark py-2 bg-card-header">
                            <i className="bi bi-box-seam me-2 grid-icon" />
                            Items to Carry
                          </div>
                          <div className="card-body px-2 pt-1 pb-2">
                            <p className="fw-semibold mb-0">
                              Please list the items (bags, cartons, packages, etc.)
                              you wish to carry in the exhibition:
                            </p>
                            <div className="table-responsive ">
                              <table
                                className="table table-bordered table-sm mb-2"
                                id="itemsTable1"
                              >
                                <thead className="table-light">
                                  <tr>
                                    <th style={{ width: 60, textAlign: "center" }}>
                                      Sr. No.
                                    </th>
                                    <th>
                                      Item Name<span className="text-red">*</span>
                                    </th>
                                    <th style={{ width: 110, textAlign: "center" }}>
                                      Qty<span className="text-red">*</span>
                                    </th>
                                    <th style={{ width: 60, textAlign: "center" }}>
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {itemToCarryList.length > 0 &&
                                    itemToCarryList.map((item, i) => (
                                      <tr>
                                        <td className="text-center">{i + 1}</td>
                                        <td>
                                          <input
                                            type="text"
                                            style={{
                                              border:
                                                item.Nameerr && "1px solid red",
                                            }}
                                            className="form-control form-control-sm w-100 px-1 w-100"
                                            placeholder="Enter item"
                                            maxLength={200}
                                            value={item.Name}
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "Name",
                                                i
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="text-center">
                                          <input
                                            type="text"
                                            className="form-control form-control-sm w-100 text-center"
                                            maxLength={10}
                                            style={{
                                              border:
                                                item.Quantityerr && "1px solid red",
                                            }}
                                            value={item.Quantity}
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "int",
                                                "Quantity",
                                                i
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="text-center">
                                          <button
                                            type="button"
                                            className="btn btn-sm"
                                            onClick={(e) => this.removeItem(i)}
                                          >
                                            <i className="bi bi-trash grid-icon" />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                            <button
                              type="button"
                              className="btn btn-blue-border mt-2 mt-md-0"
                              onClick={() => {
                                const updatedList = [...this.state.itemToCarryList];
                                updatedList.push({
                                  Name: "",
                                  Quantity: "",
                                  Nameerr: false,
                                  Quantityerr: false,
                                });
                                this.setState({ itemToCarryList: updatedList });
                              }}
                            >
                              <i className="bi bi-plus-circle me-1" /> Add More
                              Items
                            </button>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="row mt-2">
                      <div className="col d-flex justify-content-end">
                        <button
                          style={{ backgroundColor: '#51cbc0' }}
                          type="button"
                          className="btn text-white  mr-2"
                          onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to  Save As Draft?', buttonName: ' Save As Draft', action: 5 }, popArg: [1] })}
                        // onClick={() => this.submitExhibitorEntryPass(1)}
                        >
                          Save As Draft
                        </button>
                        <button
                          style={{ backgroundColor: '#51cbc0' }}
                          type="button"
                          className="btn text-white ms-2"
                          // onClick={() => this.submitExhibitorEntryPass(2)}
                          onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 6 }, popArg: [2] })}

                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    {/* Bootstrap Tooltip Init */}
                  </div>
                </section>
              }
              <Modal
                isOpen={isOpen}
                onRequestClose={() => this.setState({ isOpen: false })}
              >
                <div className="modal-dialog modal-sm">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header p-2 text-center">
                      <h5 class="modal-title modal_title_text">
                        Scan below QR in Kiosk Device for print Entry Pass
                      </h5>
                      {/* <button
                        type="button "
                        class="close pop-close"
                        data-dismiss="modal"
                        onClick={() => this.setState({ isOpen: false })}
                        style={{ background: "#eeeeee" }}
                      >
                        <span aria-hidden="true" class="pop-cancel">
                          &times;
                        </span>
                      </button> */}
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12 text-center">
                          <img
                            src={this.state.QrCodeImg}
                            alt="QR Code"
                            className="rounded-2xl shadow-lg w-64 h-64 object-contain"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer p-1">
                      <div class="form-group text-right mod-fot">
                        <button
                          type="button"
                          class="btn btn-gray"
                          data-dismiss="modal"
                          style={{ marginLeft: "5px" }}
                          onClick={() => this.setState({ isOpen: false })}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>

              <Modal
                isOpen={isCopyModal}
                onRequestClose={() => this.setState({ isCopyModal: false })}
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div class="modal-header text-white p-2">
                      <h6 class="modal-title fw-normal">
                        Share Link to Contractor
                      </h6>
                      <button
                        type="button "
                        class="btn-close btn-close-white"
                        data-dismiss="modal"
                        onClick={() => this.setState({ isCopyModal: false })}
                      // style={{ background: "#eeeeee" }}
                      >
                        {/* <span aria-hidden="true" class="pop-cancel">
                          &times;
                        </span> */}
                      </button>
                    </div>
                    <div class="modal-body">
                      <div className="table-responsive ">
                        <table
                          className="table table-bordered table-sm mb-2"
                          id="itemsTable1"
                        >
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: 60, textAlign: "center" }}>
                                Sr. No.
                              </th>
                              <th>Contractor</th>
                              <th style={{ width: 60, textAlign: "center" }}>
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {contractorList.length > 0 &&
                              contractorList.map(
                                (item, i) =>
                                  item.ContractorID != 0 && (
                                    <tr>
                                      <td className="text-center">{i + 1}</td>
                                      <td>{item.CompanyName}</td>
                                      <td className="text-center">
                                        <button
                                          type="button"
                                          className={
                                            i == copiedIndex && isCopied
                                              ? "btn btn-white text-success border-success"
                                              : "btn btn-white text-secondary border-secondary"
                                          }
                                          // onClick={() => this.submitExhibitorEntryPass()}
                                          onClick={() =>
                                            this.copyToClipboard(item.UUID, i)
                                          }
                                        >
                                          {i == copiedIndex && isCopied ? (
                                            <span className="text-success">
                                              <i
                                                class="fa fa-check text-success"
                                                aria-hidden="true"
                                              ></i>{" "}
                                              Copied
                                            </span>
                                          ) : (
                                            "Copy Link"
                                          )}
                                        </button>
                                      </td>
                                    </tr>
                                  )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-gray"
                        data-dismiss="modal"
                        // style={{ marginLeft: "5px" }}
                        onClick={() => this.setState({ isCopyModal: false })}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
              <Modal isOpen={this.state.isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                <div className="modal-dialog" style={{ marginTop: '20%' }}>
                  <div className="modal-content confirm-logout">
                    <div class="modal-header text-right p-2">
                      <h5 class="modal-title modal_title_text text-Primary">   Confirm Delete</h5>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <p class="pop_label">Do you really want to delete this Document?</p>
                      </div>
                    </div>
                    <div class="modal-footer p-1">
                      <div class="form-group text-right mod-fot">
                        <button type="button" className="btn btn-aqua"
                          onClick={() => this.deleteEntryPassDoc()}
                        >Yes</button>
                        <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                          onClick={() => this.setState({ isDelOpen: false })}
                        >No</button>
                      </div>
                    </div>

                  </div>
                </div>
              </Modal >
              <Modal isOpen={deletePop} onRequestClose={() => this.setState({ deletePop: false })}>
                <div className="modal-dialog">
                  <div className="modal-content confirm-logout">
                    <div class="modal-header bg-danger text-white py-2">
                      <h5 class="modal-title" style={{ fontSize: "16px" }}>Delete Entry Pass</h5>
                      <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ deletePop: false })} ></button>
                    </div>
                    <div class="modal-body">
                      Do you want to delete this Entry Pass?
                    </div>
                    <div class="modal-footer p-1">
                      <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ deletePop: false })}>No</button>
                      <button type="button" class="btn btn-danger" onClick={() => this.deleteEntryPass()}>Yes</button>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          </div >
        </div >
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getExhibitorEntryPassDetails_action,
    submitExhibitorEntryPass_action,
    getAccountEntryPassDetail_action, deleteEntryPass_action,
    getVendorBasicDetail_action, deleteEntryPassDriverDoc_action,
    getEntryPassPdf_action, updateExhibitorEntryPass_action,
  })(ExhibitorEntryPass)
);
